<template>
  <div class="header">
    <div class="container-fluid">
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <!-- Breadcrumb Section -->
            <!-- Breadcrumb and Buttons Section in the same row -->
            <div class="row align-items-center">
              <!-- Left side: Breadcrumb -->
              <div class="col d-flex align-items-center">
                <p class="mb-0">
                  Ideation <span class="fe fe-chevron-right"></span> Overview
                </p>
              </div>
              <!-- Right side: Buttons -->
              <div
                class="col-auto"
                v-if="isGentaGendisRole(details?.overview?.status)"
              >
                <b-button
                  variant="success"
                  class="mr-2"
                  @click="openModalGG('verif')"
                  >Verify</b-button
                >
                <b-button variant="warning" @click="openModalGG('revision')"
                  >Revision</b-button
                >
              </div>
              <div
                class="col-auto"
                v-if="isDemandTouchpointRole(details?.overview?.status)"
              >
                <b-button
                  v-if="['Super Admin', 'Demand Touchpoint'].includes(roles)"
                  variant="info"
                  class="mr-2"
                  @click="showModalNotification('acknowledge')"
                  >Acknowledge Demand Touch Point</b-button
                >
                <b-button
                  variant="success"
                  class="mr-2"
                  @click="openModalDp('verif')"
                  >Verify</b-button
                >
                <b-button variant="warning" @click="openModalDp('revision')"
                  >Revision</b-button
                >
              </div>
              <div
                class="col-auto"
                v-if="isSpgVerifRole(details?.overview?.status)"
              >
                <b-button
                  variant="success"
                  class="mr-2"
                  @click="openModalVerifSpg('verif')"
                  >Verify
                </b-button>
                <b-button
                  variant="warning"
                  class="mr-2"
                  @click="openModalVerifSpg('revision')"
                  >Revision
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-2"
                  @click="openModalVerifSpg('reject')"
                  >Reject
                </b-button>
                <b-button
                  variant="secondary"
                  @click="
                    openModalVerifSpg(
                      details?.overview?.status == 'Hold By SPG'
                        ? 'Unhold'
                        : 'Hold'
                    )
                  "
                >
                  {{
                    details?.overview?.status == "Hold By SPG"
                      ? "Unhold"
                      : "Hold"
                  }}
                </b-button>
              </div>
              <div
                class="col-auto"
                v-if="isDemandSolutionRole(details?.overview?.status)"
              >
                <b-button
                  variant="success"
                  class="mr-2"
                  @click="openModalDs('verif')"
                  >Verify</b-button
                >
                <b-button
                  variant="warning"
                  class="mr-2"
                  @click="openModalDs('revision')"
                  >Revision</b-button
                >
              </div>
              <div
                class="col-auto"
                v-if="isDifoRole(details?.overview?.status)"
              >
                <b-button
                  variant="success"
                  class="mr-2"
                  @click="openModalDifo('verif')"
                  >Verify
                </b-button>
                <b-button
                  variant="warning"
                  class="mr-2"
                  @click="openModalDifo('revision')"
                  >Revision
                </b-button>
              </div>
              <div
                class="col-auto"
                v-if="isSpgFinalizationRole(details?.overview?.status)"
              >
                <b-button
                  variant="success"
                  class="mr-2"
                  @click="openModalSpgFinal('verif')"
                >
                  Finalization</b-button
                >
                <b-button
                  variant="warning"
                  class="mr-2"
                  @click="openModalSpgFinal('revision')"
                >
                  Revision</b-button
                >
              </div>
              <div
                class="col-auto"
                v-if="isSpgKickoffRole(details?.overview?.status)"
              >
                <b-button
                  variant="info"
                  class="mr-2"
                  @click="openModalSpgKickoff('verif')"
                  >Kick Off
                </b-button>
                <b-button
                  variant="warning"
                  class="mr-2"
                  @click="openModalSpgKickoff('revision')"
                  >Revision
                </b-button>
              </div>
              <div
                class="col-auto"
                v-if="
                  isProjectDevelopmentDifo(
                    details?.overview?.status,
                    details?.overview?.is_module_closed
                  )
                "
              >
                <b-button
                  variant="primary"
                  class="mr-2"
                  @click="openModalProjectDevelopment('final')"
                >
                  Final Realese</b-button
                >
                <b-button
                  variant="info"
                  @click="openModalProjectDevelopment('partial')"
                  >Partial Realese
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <b-overlay :show="show" rounded="sm">
        <div class="card">
          <div class="card-body">
            <div class="list-group list-group-flush">
              <div class="p-2">
                <div class="row justify-content-between align-items-center">
                  <div class="col-lg-3">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-book-open"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">
                          Project Ideation Name
                        </h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          <span
                            v-b-popover.hover.right="details?.overview?.name"
                            v-for="(part, index) in splitText(
                              details?.overview?.name,
                              30
                            )"
                            :key="index"
                          >
                            {{ part }}<br />
                          </span>
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5 mt-sm-0">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-calendar"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">Ideation Date</h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{ details?.overview?.date }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5 mt-sm-0">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-clock"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">Time Delivery</h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{ details?.overview?.time_delivery }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5 mt-sm-0">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-flag"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">Scope</h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{ details?.overview?.scope }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-refresh-ccw"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">
                          Revisioned by General User (Total)
                        </h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{
                            details?.overview?.revision_counter
                              ? details?.overview?.revision_counter
                              : "0"
                          }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-refresh-ccw"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">
                          Revisioned by Genta/Gendis (Total)
                        </h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{
                            details.genta_gendis_flow
                              ? details?.genta_gendis_flow?.revision_counter
                              : "0"
                          }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-refresh-ccw"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">
                          Revisioned by Demand Solution (Total)
                        </h4>
                        <!-- Text -->
                        <small class="text-body-secondary"> 0 </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-refresh-ccw"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">
                          Acknowledge by Demand Touchpoint (Total)
                        </h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{ details?.overview?.acknowledge_count }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                  <div class="col-lg-3 mt-5">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div
                            class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary"
                          >
                            <i class="fe fe-git-commit"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col ms-n2">
                        <!-- Heading -->
                        <h4 class="mb-1 font-weight-bold">Status</h4>
                        <!-- Text -->
                        <small class="text-body-secondary">
                          {{ details?.overview?.status }}
                        </small>
                      </div>
                    </div>
                    <!-- / .row -->
                  </div>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col ms-n2">
                            <!-- Title -->
                            <h4 class="mb-1 font-weight-bold">
                              Requestor Name
                            </h4>

                            <!-- Text -->
                            <p class="small text-body-secondary mb-1">
                              Employee Name:
                              {{ details?.overview?.requestor.fullname }}
                            </p>

                            <!-- Status -->
                            <p class="small mb-0">
                              Department:
                              {{
                                details?.overview?.requestor.department
                                  ? details?.overview?.requestor.department
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                        <!-- / .row -->
                      </div>
                      <!-- / .card-body -->
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col ms-n2">
                            <!-- Title -->
                            <h4 class="mb-1 font-weight-bold">Genta/Gendis</h4>

                            <!-- Text -->
                            <p class="small text-body-secondary mb-1">
                              Employee Name:
                              {{ details?.genta_gendis_flow?.fullname }}
                            </p>

                            <!-- Status -->
                            <p class="small mb-0">
                              Department:
                              {{
                                details?.genta_gendis_flow?.department
                                  ? details?.genta_gendis_flow?.department
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                        <!-- / .row -->
                      </div>
                      <!-- / .card-body -->
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col ms-n2">
                            <!-- Title -->
                            <h4 class="mb-1 font-weight-bold">Created by</h4>

                            <!-- Text -->
                            <p class="small text-body-secondary mb-1">
                              Employee Name:
                              {{ details?.overview?.created_by.fullname }}
                            </p>

                            <!-- Status -->
                            <p class="small mb-0">
                              Department:
                              {{
                                details?.overview?.created_by.department
                                  ? details?.overview?.created_by.department
                                  : "-"
                              }}
                            </p>
                          </div>
                        </div>
                        <!-- / .row -->
                      </div>
                      <!-- / .card-body -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">Ideation Background</div>
              </div>
              <div class="card-body">
                <b-tabs class="p-0" fill>
                  <b-tab title="Background" active>
                    <b-card-text>
                      <div class="list-group list-group-flush m-3">
                        <div
                          class="list-group-item p-2"
                          style="border-bottom: solid 0px"
                        >
                          <div class="row mt-5">
                            <div
                              class="col-lg-4"
                              v-for="(item, index) in backgroundList(
                                details?.overview?.background
                              )"
                              :key="index"
                            >
                              <div class="card">
                                <div class="card-body">
                                  <div class="row align-items-center">
                                    <div class="col ms-n2">
                                      <!-- Title -->
                                      <h4 class="mb-1 font-weight-bold">
                                        {{ item.label }}
                                      </h4>

                                      <!-- Status -->
                                      <p class="small mb-0">
                                        Reason :
                                        <span class="text-muted">{{
                                          item.reason ? item.reason : "-"
                                        }}</span>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- / .row -->
                                </div>
                                <!-- / .card-body -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Commercial Benefit">
                    <b-card-text>
                      <div class="list-group list-group-flush m-3">
                        <div
                          class="list-group-item p-2"
                          style="border-bottom: solid 0px"
                        >
                          <div class="row mt-5">
                            <div
                              class="col-lg-4"
                              v-for="(item, index) in benefitList(
                                details?.overview?.benefit[0].items
                              )"
                              :key="index"
                            >
                              <div class="card">
                                <div class="card-body">
                                  <div class="row align-items-center">
                                    <div class="col ms-n2">
                                      <!-- Title -->
                                      <h4 class="mb-1 font-weight-bold">
                                        {{ item.label }}
                                      </h4>

                                      <!-- Status -->
                                      <p class="small mb-0">
                                        Reason :
                                        <span class="text-muted">{{
                                          item.reason ? item.reason : "-"
                                        }}</span>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- / .row -->
                                </div>
                                <!-- / .card-body -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Payback Period">
                    <b-card-text>
                      <div class="list-group list-group-flush m-3">
                        <div
                          class="list-group-item p-2"
                          style="border-bottom: solid 0px"
                        >
                          <div class="row mt-5">
                            <div class="col-lg-4">
                              <div class="card">
                                <div class="card-body">
                                  <div class="row align-items-center">
                                    <div class="col ms-n2">
                                      <!-- Title -->
                                      <h4 class="mb-1 font-weight-bold">
                                        {{
                                          details?.overview?.benefit[1].value
                                        }}
                                      </h4>

                                      <!-- Status -->
                                      <p class="small mb-0">
                                        Reason :
                                        <span class="text-muted">{{
                                          details?.overview?.benefit[1].reason
                                        }}</span>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- / .row -->
                                </div>
                                <!-- / .card-body -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab
                    title="Budget Availability"
                    v-if="details?.overview?.budget_availability?.[1]?.value"
                  >
                    <b-card-text>
                      <div class="list-group list-group-flush m-3">
                        <div
                          class="list-group-item p-2"
                          style="border-bottom: solid 0px"
                        >
                          <div class="row mt-5">
                            <div class="col-lg-4">
                              <div class="card">
                                <div class="card-body">
                                  <div class="row align-items-center">
                                    <div class="col ms-n2">
                                      <!-- Title -->
                                      <h4 class="mb-1 font-weight-bold">
                                        {{
                                          details?.overview
                                            ?.budget_availability[1].value
                                        }}
                                      </h4>
                                    </div>
                                  </div>
                                  <!-- / .row -->
                                </div>
                                <!-- / .card-body -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab
                    title="Expected Business Process"
                    v-if="details?.overview?.expected_business_process"
                  >
                    <b-card-text>
                      <div class="list-group list-group-flush m-3">
                        <div
                          class="list-group-item p-2"
                          style="border-bottom: solid 0px"
                        >
                          <div class="row mt-5">
                            <div class="col-lg-12">
                              <div class="card">
                                <div class="card-body">
                                  <div class="row align-items-center">
                                    <div class="col ms-n2">
                                      <!-- Title -->
                                      <h4 class="mb-1 font-weight-bold">
                                        {{
                                          details?.overview
                                            ?.expected_business_process
                                        }}
                                      </h4>
                                    </div>
                                  </div>
                                  <!-- / .row -->
                                </div>
                                <!-- / .card-body -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">Ideation Scope</div>
              </div>
              <div class="card-body">
                <b-tabs content-class="mt-3" fill>
                  <b-tab title="Genta/Gendis">
                    <div v-if="flows[1]?.created_at">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Genta/Gendis Verified by</label
                        >
                        <p>{{ details?.genta_gendis_flow?.fullname }}</p>
                      </div>
                      <div class="card">
                        <div class="card-body">
                          <div class="row align-items-center">
                            <div class="col ms-n2">
                              <!-- Title -->
                              <h4 class="mb-1 font-weight-bold">
                                Verified Notes
                              </h4>

                              <!-- Text -->
                              <p class="small text-body-secondary mb-1">
                                {{ details?.genta_gendis_flow?.notes }}
                              </p>
                            </div>
                          </div>
                          <!-- / .row -->
                        </div>
                        <!-- / .card-body -->
                      </div>
                    </div>

                    <!-- <b-tabs content-class="mt-3">
                                            <b-tab :title="`Revision Notes ${index + 1}`"
                                                v-for="(dts, index) in details?.genta_gendis_flow?.revision"
                                                :key="index">
                                                <div class="form-group">
                                                    <label class="font-weight-bold">Revision Request by</label>
                                                    <p class="mt-0">{{ dts.action_by }}</p>
                                                </div>
                                                <div class="form-group"
                                                    style="border: 1px solid #ccc; padding: 10px; border-radius: 5px;">
                                                    <label class="font-weight-bold">Revision Notes</label>
                                                    <p class="mt-0">{{ dts.notes ? dts.notes : "-" }}</p>
                                                </div>
                                            </b-tab>
                                        </b-tabs> -->
                  </b-tab>
                  <b-tab title="Demand Touchpoint" v-if="flows[2]?.created_at">
                    <div class="form-group">
                      <label class="font-weight-bold"
                        >Demand Touchpoint Verified by</label
                      >
                      <p>{{ details.demand_touch_point_flow.fullname }}</p>
                    </div>
                    <div class="row mt-5">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in details.demand_touch_point_flow
                          .final_requirement_document"
                        :key="index"
                      >
                        <div class="card">
                          <div class="card-body">
                            <div class="row align-items-center">
                              <div class="col ms-n2">
                                <!-- Title -->
                                <h4 class="mb-1 font-weight-bold">
                                  {{ item.title }}
                                </h4>

                                <!-- Text -->
                                <p class="small text-body-secondary mb-1">
                                  Link :
                                  <b-link @click="functionLink(item.link)">
                                    {{
                                      item.link.length > 33
                                        ? item.link.slice(0, 33) + "..."
                                        : item.link
                                    }}
                                  </b-link>
                                </p>

                                <!-- Status -->
                                <p class="small mb-0">
                                  Notes :
                                  <span class="text-muted">{{
                                    item.notes ? item.notes : "-"
                                  }}</span>
                                </p>
                              </div>
                            </div>
                            <!-- / .row -->
                          </div>
                          <!-- / .card-body -->
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="SPG" v-if="flows[3]?.created_at">
                    <div class="form-group">
                      <label class="font-weight-bold">SPG Verified by</label>
                      <p>{{ details.spg_flow.fullname }}</p>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col ms-n2">
                            <!-- Title -->
                            <h4 class="mb-1 font-weight-bold">
                              Verified Notes
                            </h4>

                            <!-- Text -->
                            <p class="small text-body-secondary mb-1">
                              {{ details.spg_flow.time_delivery_spg.notes }}
                            </p>
                          </div>
                        </div>
                        <!-- / .row -->
                      </div>
                      <!-- / .card-body -->
                    </div>
                    <!-- <div class="form-group">
                                            <label class="font-weight-bold">Notes</label>
                                            <p>{{details.spg_flow.time_delivery_spg.notes}}</p>
                                        </div> -->
                    <div class="card">
                      <div class="card-header">
                        <div class="card-header-title">
                          Resource Availability Assessment
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="form group">
                              <label class="font-weight-bold text-secondary"
                                >Man Power</label
                              >
                              <p>
                                {{
                                  details.spg_flow.resource_availability
                                    .man_power
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="form group">
                              <label class="font-weight-bold text-secondary"
                                >Budget</label
                              >
                              <p>
                                {{
                                  details.spg_flow.resource_availability.budget
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="form group">
                              <label class="font-weight-bold text-secondary"
                                >High Depedency with Existing Solution</label
                              >
                              <p>{{ details.spg_flow.high_dependency }}</p>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="form group">
                                  <label class="font-weight-bold text-secondary"
                                    >Time Delivery</label
                                  >
                                  <p>
                                    {{
                                      details.spg_flow.time_delivery_spg.value
                                    }}
                                  </p>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                <div class="form group">
                                  <label class="font-weight-bold text-secondary"
                                    >Estimated Time Delivery</label
                                  >
                                  <p>
                                    {{
                                      details.spg_flow
                                        ?.estimated_time_delivery_spg?.week &&
                                      details.spg_flow
                                        ?.estimated_time_delivery_spg?.month &&
                                      details.spg_flow
                                        ?.estimated_time_delivery_spg?.year
                                        ? details.spg_flow
                                            .estimated_time_delivery_spg.week +
                                          ", " +
                                          details.spg_flow
                                            .estimated_time_delivery_spg.month +
                                          " " +
                                          details.spg_flow
                                            .estimated_time_delivery_spg.year
                                        : "-"
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Demand Solution" v-if="flows[4]?.created_at">
                    <div class="form-group">
                      <label class="font-weight-bold"
                        >Demand Demand Solution Verified by</label
                      >
                      <p>{{ details.demand_solution_flow.fullname }}</p>
                    </div>
                    <div class="row mt-5">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in details.demand_solution_flow
                          .high_level_spesification"
                        :key="index"
                      >
                        <div class="card">
                          <div class="card-body">
                            <div class="row align-items-center">
                              <div class="col ms-n2">
                                <!-- Title -->
                                <h4 class="mb-1 font-weight-bold">
                                  {{ item.title }}
                                </h4>

                                <!-- Text -->
                                <p class="small text-body-secondary mb-1">
                                  Link :
                                  <b-link @click="functionLink(item.link)">
                                    {{
                                      item.link.length > 33
                                        ? item.link.slice(0, 33) + "..."
                                        : item.link
                                    }}
                                  </b-link>
                                </p>

                                <!-- Status -->
                                <p class="small mb-0">
                                  Notes :
                                  <span class="text-muted">{{
                                    item.notes ? item.notes : "-"
                                  }}</span>
                                </p>
                              </div>
                            </div>
                            <!-- / .row -->
                          </div>
                          <!-- / .card-body -->
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="DIFO" v-if="flows[5]?.created_at">
                    <div class="form-group">
                      <label class="font-weight-bold">DIFO Verified by</label>
                      <p>{{ details.difo_flow.fullname }}</p>
                    </div>
                    <div class="row mt-5">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in details.difo_flow
                          .technical_spesification_design"
                        :key="index"
                      >
                        <div class="card">
                          <div class="card-body">
                            <div class="row align-items-center">
                              <div class="col ms-n2">
                                <!-- Title -->
                                <h4 class="mb-1 font-weight-bold">
                                  {{ item.title }}
                                </h4>

                                <!-- Text -->
                                <p class="small text-body-secondary mb-1">
                                  Link :
                                  <b-link @click="functionLink(item.link)">
                                    {{
                                      item.link.length > 33
                                        ? item.link.slice(0, 33) + "..."
                                        : item.link
                                    }}
                                  </b-link>
                                </p>

                                <!-- Status -->
                                <p class="small mb-0">
                                  Notes :
                                  <span class="text-muted">{{
                                    item.notes ? item.notes : "-"
                                  }}</span>
                                </p>
                              </div>
                            </div>
                            <!-- / .row -->
                          </div>
                          <!-- / .card-body -->
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Finalization SPG" v-if="flows[6]?.created_at">
                    <div class="form-group">
                      <label class="font-weight-bold"
                        >SPG Finalization by</label
                      >
                      <p>{{ details.finalization_flow.fullname }}</p>
                    </div>
                    <div class="row mt-5">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in details.finalization_flow
                          .requirement_boarding_spg"
                        :key="index"
                      >
                        <div class="card">
                          <div class="card-body">
                            <div class="row align-items-center">
                              <div class="col ms-n2">
                                <!-- Title -->
                                <h4 class="mb-1 font-weight-bold">
                                  {{ item.title }}
                                </h4>

                                <!-- Text -->
                                <p class="small text-body-secondary mb-1">
                                  Link :
                                  <b-link @click="functionLink(item.link)">
                                    {{
                                      item.link.length > 33
                                        ? item.link.slice(0, 33) + "..."
                                        : item.link
                                    }}
                                  </b-link>
                                </p>

                                <!-- Status -->
                                <p class="small mb-0">
                                  Notes :
                                  <span class="text-muted">{{
                                    item.notes ? item.notes : "-"
                                  }}</span>
                                </p>
                              </div>
                            </div>
                            <!-- / .row -->
                          </div>
                          <!-- / .card-body -->
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Kickoff SPG" v-if="flows[7]?.created_at">
                    <div class="form-group">
                      <label class="font-weight-bold">SPG Kickoff by</label>
                      <p>{{ details.kickoff_flow.fullname }}</p>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col ms-n2">
                            <!-- Title -->
                            <h4 class="mb-1 font-weight-bold">Kickoff Notes</h4>

                            <!-- Text -->
                            <p class="small text-body-secondary mb-1">
                              {{ details.kickoff_flow.kickoff_notes }}
                            </p>
                          </div>
                        </div>
                        <!-- / .row -->
                      </div>
                      <!-- / .card-body -->
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
            <!-- v-if="'project_development_flow' in details" -->
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">
                  Development Scope
                  {{
                    !details || details.project_development_flow == null
                      ? ""
                      : Array.isArray(details.project_development_flow)
                      ? " > Partial Release"
                      : " > Full Release"
                  }}
                </div>
              </div>
              <div class="card-body">
                <b-tabs v-if="details.project_development_flow" fill>
                  <b-tab title="DIFO - Project Development">
                    <div
                      v-if="
                        Array.isArray(details.project_development_flow) == true
                          ? true
                          : false
                      "
                    >
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columnsProjectDevelopment"
                        :rows="checkData(details.project_development_flow)"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'feature'">
                            {{ convertFeature(props.row.feature) }}
                          </span>
                          <span v-else-if="props.column.field == 'action'">
                            <div class="text-center d-flex">
                              <b-button
                                variant="info"
                                size="sm"
                                @click="openModalDetailDevelopment(props.row)"
                                ><span class="fe fe-eye"></span
                              ></b-button>
                            </div>
                          </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="1"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </div>
                    <div v-else>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Module</th>
                              <th scope="col">Feature</th>
                              <th scope="col">Latest Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>
                                {{
                                  details.project_development_flow.module_name
                                }}
                              </th>
                              <td>
                                {{
                                  convertFeature(
                                    details.project_development_flow.feature
                                  )
                                }}
                              </td>
                              <td>
                                {{ details.project_development_flow.status }}
                              </td>
                              <td>
                                <div class="text-center d-flex">
                                  <b-button
                                    variant="info"
                                    size="sm"
                                    @click="
                                      openModalDetailDevelopment(
                                        details.project_development_flow
                                      )
                                    "
                                  >
                                    <span class="fe fe-eye"></span
                                  ></b-button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="SPG - Pra Go Live">
                    <div
                      v-if="
                        Array.isArray(details.project_development_flow) == true
                          ? true
                          : false
                      "
                    >
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columnsProjectDevelopment"
                        :rows="checkData(details.project_development_flow)"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'feature'">
                            {{ convertFeature(props.row.feature) }}
                          </span>
                          <span v-else-if="props.column.field == 'action'">
                            <div class="text-center d-flex">
                              <b-button variant="info" size="sm"
                                ><span
                                  class="fe fe-eye"
                                  @click="openModalDetailDevelopment(props.row)"
                                ></span>
                              </b-button>
                              <b-button
                                v-if="isPragoliveRole(props.row.status)"
                                class="ml-3"
                                variant="primary"
                                size="sm"
                                @click="
                                  openModalPragolive('pra_golive', props.row.id)
                                "
                              >
                                Pra Go Live
                              </b-button>
                            </div>
                          </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="1"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </div>
                    <div v-else>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Module</th>
                              <th scope="col">Feature</th>
                              <th scope="col">Latest Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>
                                {{
                                  details.project_development_flow.module_name
                                }}
                              </th>
                              <td>
                                {{
                                  convertFeature(
                                    details.project_development_flow.feature
                                  )
                                }}
                              </td>
                              <td>
                                {{ details.project_development_flow.status }}
                              </td>
                              <td>
                                <div class="text-center d-flex">
                                  <b-button
                                    variant="info"
                                    size="sm"
                                    @click="
                                      openModalDetailDevelopment(
                                        details.project_development_flow
                                      )
                                    "
                                  >
                                    <span class="fe fe-eye"></span
                                  ></b-button>
                                  <b-button
                                    v-if="
                                      isPragoliveRole(
                                        details.project_development_flow.status
                                      )
                                    "
                                    class="ml-3"
                                    variant="primary"
                                    size="sm"
                                    @click="
                                      openModalPragolive(
                                        'pra_golive',
                                        details.project_development_flow.id
                                      )
                                    "
                                  >
                                    Pra Go Live</b-button
                                  >
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="SPG - Go Live">
                    <div
                      v-if="
                        Array.isArray(details.project_development_flow) == true
                          ? true
                          : false
                      "
                    >
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columnsProjectDevelopment"
                        :rows="checkData(details.project_development_flow)"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'feature'">
                            {{ convertFeature(props.row.feature) }}
                          </span>
                          <span v-else-if="props.column.field == 'action'">
                            <div class="text-center d-flex">
                              <b-button
                                variant="info"
                                size="sm"
                                @click="openModalDetailDevelopment(props.row)"
                                ><span class="fe fe-eye"></span
                              ></b-button>
                              <b-button
                                v-if="isGoLiveRole(props.row.status)"
                                class="ml-3"
                                variant="primary"
                                size="sm"
                                @click="openModalGoLive('golive', props.row.id)"
                              >
                                Go Live
                              </b-button>
                            </div>
                          </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="1"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </div>
                    <div v-else>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Module</th>
                              <th scope="col">Feature</th>
                              <th scope="col">Latest Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>
                                {{
                                  details.project_development_flow.module_name
                                }}
                              </th>
                              <td>
                                {{
                                  convertFeature(
                                    details.project_development_flow.feature
                                  )
                                }}
                              </td>
                              <td>
                                {{ details.project_development_flow.status }}
                              </td>
                              <td>
                                <div class="text-center d-flex">
                                  <b-button
                                    variant="info"
                                    size="sm"
                                    @click="
                                      openModalDetailDevelopment(
                                        details.project_development_flow
                                      )
                                    "
                                  >
                                    <span class="fe fe-eye"></span
                                  ></b-button>
                                  <b-button
                                    v-if="
                                      isGoLiveRole(
                                        details.project_development_flow.status
                                      )
                                    "
                                    class="ml-3"
                                    variant="primary"
                                    size="sm"
                                    @click="
                                      openModalGoLive(
                                        'golive',
                                        details.project_development_flow.id
                                      )
                                    "
                                  >
                                    Go Live</b-button
                                  >
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Demand Touchpoint - Monitoring">
                    <div
                      v-if="
                        Array.isArray(details.project_development_flow) == true
                          ? true
                          : false
                      "
                    >
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columnsProjectDevelopment"
                        :rows="checkData(details.project_development_flow)"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'feature'">
                            {{ convertFeature(props.row.feature) }}
                          </span>
                          <span v-else-if="props.column.field == 'action'">
                            <div class="text-center d-flex">
                              <b-button
                                variant="info"
                                size="sm"
                                @click="openModalDetailDevelopment(props.row)"
                                ><span class="fe fe-eye"></span
                              ></b-button>
                              <b-button
                                v-if="isMonitoringFlow(props.row.status)"
                                class="ml-3"
                                variant="primary"
                                size="sm"
                                @click="
                                  openModalMonitoring(
                                    'monitoring',
                                    props.row.id
                                  )
                                "
                              >
                                Monitoring
                              </b-button>
                            </div>
                          </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="1"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </div>
                    <div v-else>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Module</th>
                              <th scope="col">Feature</th>
                              <th scope="col">Latest Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>
                                {{
                                  details.project_development_flow.module_name
                                }}
                              </th>
                              <td>
                                {{
                                  convertFeature(
                                    details.project_development_flow.feature
                                  )
                                }}
                              </td>
                              <td>
                                {{ details.project_development_flow.status }}
                              </td>
                              <td>
                                <div class="text-center d-flex">
                                  <b-button
                                    variant="info"
                                    size="sm"
                                    @click="
                                      openModalDetailDevelopment(
                                        details.project_development_flow
                                      )
                                    "
                                  >
                                    <span class="fe fe-eye"></span
                                  ></b-button>
                                  <b-button
                                    v-if="
                                      isMonitoringFlow(
                                        details.project_development_flow.status
                                      )
                                    "
                                    class="ml-3"
                                    variant="primary"
                                    size="sm"
                                    @click="
                                      openModalMonitoring(
                                        'monitoring',
                                        details.project_development_flow.id
                                      )
                                    "
                                  >
                                    Monitoring</b-button
                                  >
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="DSO">
                    <div
                      v-if="
                        Array.isArray(details.project_development_flow) == true
                          ? true
                          : false
                      "
                    >
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columnsProjectDevelopment"
                        :rows="checkData(details.project_development_flow)"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'feature'">
                            {{ convertFeature(props.row.feature) }}
                          </span>
                          <span v-else-if="props.column.field == 'action'">
                            <div class="text-center d-flex">
                              <b-button
                                variant="info"
                                size="sm"
                                @click="openModalDetailDevelopment(props.row)"
                                ><span class="fe fe-eye"></span
                              ></b-button>
                            </div>
                          </span>
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="1"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </div>
                    <div v-else>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Module</th>
                              <th scope="col">Feature</th>
                              <th scope="col">Latest Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>
                                {{
                                  details.project_development_flow.module_name
                                }}
                              </th>
                              <td>
                                {{
                                  convertFeature(
                                    details.project_development_flow.feature
                                  )
                                }}
                              </td>
                              <td>
                                {{ details.project_development_flow.status }}
                              </td>
                              <td>
                                <div class="text-center d-flex">
                                  <b-button
                                    variant="info"
                                    size="sm"
                                    @click="
                                      openModalDetailDevelopment(
                                        details.project_development_flow
                                      )
                                    "
                                  >
                                    <span class="fe fe-eye"></span
                                  ></b-button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
                <b-tabs v-else fill>
                  <b-tab title="DIFO - Project Development">
                    <b-alert class="mt-3 text-center" show variant="danger"
                      >No Data Available
                      <span
                        class="fe fe-alert-triangle"
                        style="color: yellow"
                      ></span
                    ></b-alert>
                  </b-tab>
                  <b-tab title="SPG - Pra Go Live">
                    <b-alert class="mt-3 text-center" show variant="danger"
                      >No Data Available
                      <span
                        class="fe fe-alert-triangle"
                        style="color: yellow"
                      ></span
                    ></b-alert>
                  </b-tab>
                  <b-tab title="SPG - Go Live">
                    <b-alert class="mt-3 text-center" show variant="danger"
                      >No Data Available
                      <span
                        class="fe fe-alert-triangle"
                        style="color: yellow"
                      ></span
                    ></b-alert>
                  </b-tab>
                  <b-tab title="Demand Touchpoint - Monitoring">
                    <b-alert class="mt-3 text-center" show variant="danger"
                      >No Data Available
                      <span
                        class="fe fe-alert-triangle"
                        style="color: yellow"
                      ></span
                    ></b-alert>
                  </b-tab>
                  <b-tab title="DSO">
                    <b-alert class="mt-3 text-center" show variant="danger"
                      >No Data Available
                      <span
                        class="fe fe-alert-triangle"
                        style="color: yellow"
                      ></span
                    ></b-alert>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <b-tabs class="p-0" fill>
                  <b-tab title="Digital Flow Update" active>
                    <b-card-text>
                      <div class="list-group list-group-flush m-3">
                        <div
                          class="list-group-item p-2"
                          style="border-bottom: solid 0px"
                        >
                          <div class="row gy-2">
                            <!-- First Item -->
                            <div
                              class="col-12 col-sm-6 col-md-auto d-flex align-items-center"
                            >
                              <div class="avatar avatar-sm me-2">
                                <div
                                  class="avatar-title fs-lg bg-info-soft rounded text-primary"
                                ></div>
                              </div>
                              <h4 class="mb-0 font-weight-bold">
                                Currently Flow
                              </h4>
                            </div>
                            <!-- Second Item -->
                            <div
                              class="col-12 col-sm-6 col-md-auto d-flex align-items-center"
                            >
                              <div class="avatar avatar-sm me-2">
                                <div
                                  class="avatar-title fs-lg bg-danger-soft rounded text-primary"
                                ></div>
                              </div>
                              <h4 class="mb-0 font-weight-bold">Coming Flow</h4>
                            </div>
                            <!-- Third Item -->
                            <div
                              class="col-12 col-sm-6 col-md-auto d-flex align-items-center"
                            >
                              <div class="avatar avatar-sm me-2">
                                <div
                                  class="avatar-title fs-lg bg-success-soft rounded text-primary"
                                ></div>
                              </div>
                              <h4 class="mb-0 font-weight-bold">Verify</h4>
                            </div>
                            <!-- Fourth Item -->
                            <div
                              class="col-12 col-sm-6 col-md-auto d-flex align-items-center"
                            >
                              <div class="avatar avatar-sm me-2">
                                <div
                                  class="avatar-title fs-lg bg-warning-soft rounded text-primary"
                                ></div>
                              </div>
                              <h4 class="mb-0 font-weight-bold">Revision</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row justify-content-center mt-4">
                        <div
                          class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 d-flex align-items-center position-relative"
                          v-for="(item, index) in flows"
                          :key="index"
                        >
                          <!-- Card -->
                          <div
                            :class="`card ${statusFlow(
                              getCreatedStatus(
                                item,
                                index,
                                details?.overview?.is_module_closed
                              )
                            )} w-100`"
                          >
                            <div class="card-body">
                              <div class="row align-items-center gx-0">
                                <div class="col">
                                  <!-- Title -->
                                  <h5
                                    :class="`text-body-secondary mb-2 text-center`"
                                  >
                                    {{ item.text }}
                                  </h5>

                                  <!-- Verification Time -->
                                  <div class="form-group mt-3">
                                    <div>
                                      <p
                                        class="small text-body-secondary text-muted"
                                      >
                                        Verification time
                                      </p>
                                      <p style="margin-top: -20px">
                                        {{ convertTime(item?.created_at) }}
                                      </p>
                                    </div>
                                    <!-- <div>
                                                                    <p class="small text-body-secondary text-muted">Reject time</p>
                                                                    <p style="margin-top: -20px;">{{ convertTime(item.created_at) }}</p>
                                                                </div> -->
                                  </div>

                                  <!-- Last Revision -->
                                  <div class="form-group mt-2">
                                    <p
                                      class="small text-body-secondary text-muted"
                                    >
                                      Last Revision
                                    </p>
                                    <p style="margin-top: -20px">
                                      {{ convertTime(item.last_revision) }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!-- / .row -->
                            </div>
                          </div>

                          <!-- Arrow Right (Outside the Card) - Hides for Last Item -->
                          <i
                            v-if="index < flows.length - 1"
                            class="fe fe-arrow-right fs-3 ms-2"
                          ></i>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Audit Trail (Ideation)">
                    <b-card-text>
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columns"
                        :rows="details?.status_logs"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table mt-3 table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'created_at'">
                            {{ convertDateDetail(props.row.created_at) }}
                          </span>
                          <span v-else-if="props.column.field == 'verify_by'">
                            {{
                              props.row.verify_by ? props.row.verify_by : "-"
                            }}
                          </span>
                          <span v-else-if="props.column.field == 'verify_at'">
                            {{ convertDate(props.row.verify_at) }}
                          </span>
                          <!-- <span v-else-if="props.column.field == 'scope'">
                                                        Ideation
                                                    </span> -->
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="details?.status_logs?.length"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="Audit Trail (Module)">
                    <b-card-text>
                      <vue-good-table
                        :line-numbers="false"
                        :columns="columnsModule"
                        :rows="details?.statusLogs_module"
                        :search-options="{
                          enabled: false,
                        }"
                        :pagination-options="{
                          enabled: true,
                          perPage: 10,
                        }"
                        style-class="vgt-table mt-3 table table-bordered"
                      >
                        <!-- Loading -->
                        <div slot="emptystate" class="text-center font-size-14">
                          No data available
                        </div>
                        <!-- Custom Rows -->
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'created_at'">
                            {{ convertDateDetail(props.row.created_at) }}
                          </span>
                          <span v-else-if="props.column.field == 'verify_by'">
                            {{
                              props.row.verify_by ? props.row.verify_by : "-"
                            }}
                          </span>
                          <span v-else-if="props.column.field == 'verify_at'">
                            {{ convertDate(props.row.verify_at) }}
                          </span>
                          <!-- <span v-else-if="props.column.field == 'scope'">
                                                        Ideation
                                                    </span> -->
                        </template>
                        <template slot="pagination-bottom" slot-scope="props">
                          <div class="d-flex justify-content-end">
                            <div>
                              <b-pagination
                                :value="1"
                                :total-rows="details?.statusLogs_module?.length"
                                :per-page="10"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="m-3"
                                @input="
                                  (value) =>
                                    props.pageChanged({ currentPage: value })
                                "
                              >
                              </b-pagination>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
            <!-- <div class="card p-3" v-if="details?.overview?.revision.length > 0">
                            <b-tabs content-class="mt-3">
                                <b-tab :title="`Revision Notes ${index + 1}`"
                                    v-for="(dts, index) in sortRevisions(details?.overview?.revision)" :key="index">
                                    <div class="form-group">
                                        <label class="font-weight-bold">Revision Request by</label>
                                        <p class="mt-0">{{ dts.action_by }}</p>
                                    </div>
                                    <div class="form-group"
                                        style="border: 1px solid #ccc; padding: 10px; border-radius: 5px;">
                                        <label class="font-weight-bold">Revision Notes</label>
                                        <p class="mt-0">{{ dts.notes ? dts.notes : "-" }}</p>
                                    </div>
                                    <p>

                                    </p>
                                </b-tab>
                            </b-tabs>
                        </div> -->

            <!-- <div class="mt-5">
                            <h2 class="font-weight-bold">Objective</h2>
                            <p>{{ details?.overview?.background[4].objective }}</p>
                        </div> -->
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">Hold Scope</div>
              </div>
              <div class="card-body">
                <b-tabs fill v-if="details.hold.length > 0">
                  <b-tab title="Hold">
                    <vsa-list style="max-width: 100% !important">
                      <vsa-item
                        v-for="(item, indexx) in paginatedHoldItems('Hold')"
                        :key="(currentPage.Hold - 1) * itemsPerPage + indexx"
                      >
                        <vsa-heading>
                          Hold
                          {{
                            totalHoldItems -
                            ((currentPage.Hold - 1) * itemsPerPage + indexx)
                          }}
                          - {{ convertDateDetail(item.created_at) }}
                        </vsa-heading>

                        <vsa-icon>
                          <span class="isOpen fe fe-chevron-down"></span>
                          <span class="isClose fe fe-chevron-up"></span>
                        </vsa-icon>

                        <vsa-content>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-weight-bold">Hold By</label>
                                <p>{{ item.action_by }}</p>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-weight-bold">Hold At</label>
                                <p>{{ convertDateDetail(item.created_at) }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="card">
                            <div class="card-body">
                              <div class="row align-items-center">
                                <div class="col ms-n2">
                                  <!-- Title -->
                                  <h4 class="mb-1 font-weight-bold">
                                    Hold Notes
                                  </h4>

                                  <!-- Text -->
                                  <p class="small text-body-secondary mb-1">
                                    {{ item.notes ? item.notes : "-" }}
                                  </p>
                                </div>
                              </div>
                              <!-- / .row -->
                            </div>
                            <!-- / .card-body -->
                          </div>
                        </vsa-content>
                      </vsa-item>
                    </vsa-list>
                    <nav aria-label="Page navigation example" class="mt-3">
                      <ul class="pagination justify-content-end">
                        <li
                          :class="[
                            'page-item',
                            { disabled: currentPage.Hold === 1 },
                          ]"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click.prevent="
                              changePage('Hold', currentPage.Hold - 1)
                            "
                            >Previous</a
                          >
                        </li>

                        <li
                          v-for="page in totalPages('Hold')"
                          :key="page"
                          :class="[
                            'page-item',
                            { active: page === currentPage.Hold },
                          ]"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click.prevent="changePage('Hold', page)"
                            >{{ page }}</a
                          >
                        </li>

                        <li
                          :class="[
                            'page-item',
                            {
                              disabled: currentPage.Hold === totalPages('Hold'),
                            },
                          ]"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click.prevent="
                              changePage('Hold', currentPage.Hold + 1)
                            "
                            >Next</a
                          >
                        </li>
                      </ul>
                    </nav>
                  </b-tab>
                  <b-tab title="Unhold">
                    <vsa-list style="max-width: 100% !important">
                      <vsa-item
                        v-for="(item, indexx) in paginatedHoldItems('Unhold')"
                        :key="(currentPage.Unhold - 1) * itemsPerPage + indexx"
                      >
                        <vsa-heading>
                          Unhold
                          {{
                            totalUnholdItems -
                            ((currentPage.Unhold - 1) * itemsPerPage + indexx)
                          }}
                          - {{ convertDateDetail(item.created_at) }}
                        </vsa-heading>

                        <vsa-icon>
                          <span class="isOpen fe fe-chevron-down"></span>
                          <span class="isClose fe fe-chevron-up"></span>
                        </vsa-icon>

                        <vsa-content>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-weight-bold"
                                  >Unhold By</label
                                >
                                <p>{{ item.action_by }}</p>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-weight-bold"
                                  >Unhold At</label
                                >
                                <p>{{ convertDateDetail(item.created_at) }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="card">
                            <div class="card-body">
                              <div class="row align-items-center">
                                <div class="col ms-n2">
                                  <!-- Title -->
                                  <h4 class="mb-1 font-weight-bold">
                                    Unhold Notes
                                  </h4>

                                  <!-- Text -->
                                  <p class="small text-body-secondary mb-1">
                                    {{ item.notes ? item.notes : "-" }}
                                  </p>
                                </div>
                              </div>
                              <!-- / .row -->
                            </div>
                            <!-- / .card-body -->
                          </div>
                        </vsa-content>
                      </vsa-item>
                    </vsa-list>
                    <nav aria-label="Page navigation example" class="mt-3">
                      <ul class="pagination justify-content-end">
                        <li
                          :class="[
                            'page-item',
                            { disabled: currentPage.Unhold === 1 },
                          ]"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click.prevent="
                              changePage('Unhold', currentPage.Unhold - 1)
                            "
                            >Previous</a
                          >
                        </li>

                        <li
                          v-for="page in totalPages('Unhold')"
                          :key="page"
                          :class="[
                            'page-item',
                            { active: page === currentPage.Unhold },
                          ]"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click.prevent="changePage('Unhold', page)"
                            >{{ page }}</a
                          >
                        </li>

                        <li
                          :class="[
                            'page-item',
                            {
                              disabled:
                                currentPage.Unhold === totalPages('Unhold'),
                            },
                          ]"
                        >
                          <a
                            class="page-link"
                            href="#"
                            @click.prevent="
                              changePage('Unhold', currentPage.Unhold + 1)
                            "
                            >Next</a
                          >
                        </li>
                      </ul>
                    </nav>
                  </b-tab>
                </b-tabs>
                <b-alert v-else class="mt-3 text-center" show variant="danger"
                  >No Data Available
                  <span
                    class="fe fe-alert-triangle"
                    style="color: yellow"
                  ></span
                ></b-alert>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">Revision Scope</div>
              </div>
              <div class="card-body">
                <b-tabs v-if="details.allRevision.length > 0" fill>
                  <b-tab
                    v-for="(item, index) in details.allRevision"
                    :key="index"
                    :title="item.name"
                  >
                    <template #title>
                      <span v-b-tooltip.hover :title="item.details">{{
                        item.name
                      }}</span>
                    </template>
                    <vsa-list
                      style="max-width: 100% !important"
                      v-if="item.revision.length > 0"
                    >
                      <vsa-item
                        v-for="(dat, indexx) in item.revision"
                        :key="indexx"
                      >
                        <vsa-heading>
                          Revision Notes {{ item.revision.length - indexx }} -
                          {{ convertDateDetail(dat.created_at) }}
                        </vsa-heading>

                        <vsa-icon>
                          <span class="isOpen fe fe-chevron-down"></span>
                          <span class="isClose fe fe-chevron-up"></span>
                        </vsa-icon>

                        <vsa-content>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-weight-bold"
                                  >Revision By</label
                                >
                                <p>{{ dat.action_by }}</p>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-group">
                                <label class="font-weight-bold"
                                  >Revision At</label
                                >
                                <p>{{ convertDateDetail(dat.created_at) }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="card">
                            <div class="card-body">
                              <div class="row align-items-center">
                                <div class="col ms-n2">
                                  <!-- Title -->
                                  <h4 class="mb-1 font-weight-bold">
                                    Revision Notes
                                  </h4>

                                  <!-- Text -->
                                  <p class="small text-body-secondary mb-1">
                                    {{ dat.notes ? dat.notes : "-" }}
                                  </p>
                                </div>
                              </div>
                              <!-- / .row -->
                            </div>
                            <!-- / .card-body -->
                          </div>
                        </vsa-content>
                      </vsa-item>
                    </vsa-list>
                    <b-alert
                      v-else
                      class="mt-3 text-center"
                      show
                      variant="danger"
                      >No Data Available
                      <span
                        class="fe fe-alert-triangle"
                        style="color: yellow"
                      ></span
                    ></b-alert>
                  </b-tab>
                </b-tabs>
                <b-alert v-else class="mt-3 text-center" show variant="danger"
                  >No Data Available
                  <span
                    class="fe fe-alert-triangle"
                    style="color: yellow"
                  ></span
                ></b-alert>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <div class="card-header-title">Rejection</div>
              </div>
              <div class="card-body">
                <div v-if="details.rejected">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Reject By</label>
                        <p>{{ details.rejected.action_by }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Reject At</label>
                        <p>
                          {{ convertDateDetail(details.rejected.created_at) }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col ms-n2">
                          <!-- Title -->
                          <h4 class="mb-1 font-weight-bold">Reject Notes</h4>

                          <!-- Text -->
                          <p class="small text-body-secondary mb-1">
                            {{
                              details.rejected.notes
                                ? details.rejected.notes
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                    <!-- / .card-body -->
                  </div>
                </div>
                <b-alert v-else class="mt-3 text-center" show variant="danger"
                  >No Data Available
                  <span
                    class="fe fe-alert-triangle"
                    style="color: yellow"
                  ></span
                ></b-alert>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
    <b-modal
      id="modal-genta-gendis"
      hide-footer
      size="lg"
      title="Validation Form"
      @hide="onHide"
    >
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" v-model="bodyNotes.notes" />
      </div>
      <div class="float-end" v-if="typeAction == 'verif'">
        <div v-if="isLoading == false">
          <b-button
            class="mr-2"
            variant="warning"
            @click="submitVerifGG('draft')"
            >Save As Draft</b-button
          >
          <b-button variant="primary" @click="submitVerifGG('submit')"
            >Submit</b-button
          >
        </div>
        <button
          v-else
          style="margin-left: auto; float: right"
          class="mt-4 btn btn-primary"
          type="button"
          disabled
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
      </div>
      <div class="float-end" v-else>
        <div v-if="isLoading == false">
          <b-button variant="primary" @click="submitVerifGG('revision')"
            >Submit</b-button
          >
        </div>
        <button
          v-else
          style="margin-left: auto; float: right"
          class="mt-4 btn btn-primary"
          type="button"
          disabled
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-demand-touchpoint"
      hide-footer
      size="xl"
      title="Validation Form"
      @hide="onHide"
    >
      <div v-if="typeAction == 'verif'">
        <div class="d-flex justify-content-between align-items-center">
          <h3>{{ isFlow ? isFlow : "" }}</h3>
          <b-button variant="primary" class="ml-auto" @click="addNewLink">
            <span class="fe fe-plus"></span> Add
          </b-button>
        </div>
        <div style="max-height: 600px !important; overflow-x: scroll">
          <div
            class="row mt-3"
            v-for="(item, index) in bodyVerifDP"
            :key="index"
          >
            <div class="col-lg-3">
              <div class="form-group">
                <label
                  >Title
                  <span
                    class="text-danger"
                    v-if="
                      index <= (isFlow === 'Final Requirement Document' ? 3 : 5)
                    "
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.title"
                  :name="`Title-${index}`"
                  v-validate="
                    index <= (isFlow === 'Final Requirement Document' ? 3 : 5)
                      ? 'required'
                      : ''
                  "
                  :disabled="
                    (isFlow === 'Final Requirement Document' && index <= 3) ||
                    (isFlow !== 'Final Requirement Document' && index <= 5)
                  "
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has(`Title-${index}`)"
                  >{{ errors.first(`Title-${index}`) }}</span
                >
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group">
                <label
                  >Shortlink
                  <span
                    class="text-danger"
                    v-if="
                      index <= (isFlow === 'Final Requirement Document' ? 3 : 5)
                    "
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.link"
                  :name="`Shortlink-${index}`"
                  v-validate="
                    index <= (isFlow === 'Final Requirement Document' ? 3 : 5)
                      ? 'required'
                      : ''
                  "
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has(`Shortlink-${index}`)"
                  >{{ errors.first(`Shortlink-${index}`) }}</span
                >
              </div>
            </div>
            <div class="col-lg-5">
              <div class="form-group">
                <label>Reason </label>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="item.notes"
                />
              </div>
            </div>
            <div
              class="col-lg-1"
              v-if="index > (isFlow === 'Final Requirement Document' ? 3 : 5)"
            >
              <b-button
                variant="primary"
                class="float-end mt-5"
                @click="clearFormVerifDP(index)"
                ><span class="fe fe-trash"></span
              ></b-button>
            </div>
          </div>
        </div>
        <div class="float-end mt-3">
          <div v-if="isLoading == false">
            <b-button
              class="mr-2"
              variant="warning"
              @click="submitVerifDemandTouchpoint(isFlow, 'draft')"
              >Save as Draft</b-button
            >
            <b-button
              variant="primary"
              @click="submitVerifDemandTouchpoint(isFlow, 'submit')"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
      <div v-else>
        <div class="form-group">
          <label>Notes</label>
          <textarea class="form-control" v-model="bodyNotes.notes" />
        </div>
        <div class="float-end mt-3">
          <div v-if="isLoading == false">
            <b-button
              variant="primary"
              v-if="isDemandTouchpointRole(details?.overview?.status)"
              @click="revisionDemandTouchpoint"
              >Submit</b-button
            >
            <b-button
              variant="primary"
              v-if="isDemandSolutionRole(details?.overview?.status)"
              @click="revisionDemandSolution"
              >Submit</b-button
            >
            <b-button
              variant="primary"
              v-if="isDifoRole(details?.overview?.status)"
              @click="revisionDIFO"
              >Submit</b-button
            >
            <b-button
              variant="primary"
              v-if="isProjectDevelopmentDifo(details?.overview?.status)"
              @click="revisionDIFO"
              >Submit</b-button
            >
            <b-button
              variant="primary"
              v-if="isSpgFinalizationRole(details?.overview?.status)"
              @click="revisionFinalization"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-verif-spg"
      hide-footer
      size="xl"
      title="Validation Form"
      @hide="onHide"
    >
      <div v-if="typeAction == 'verif'">
        <h3>Resource Availability Assessment</h3>
        <div class="row">
          <div class="col-lg-6">
            <label class="font-weight-bold"
              >Man Power <span class="text-danger">*</span></label
            >
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="bodyVerifSPG.resource_availability.man_power"
                v-validate="'required'"
                :aria-describedby="ariaDescribedby"
                name="Man Power"
                value="available"
                >Available</b-form-radio
              >
              <b-form-radio
                v-model="bodyVerifSPG.resource_availability.man_power"
                v-validate="'required'"
                :aria-describedby="ariaDescribedby"
                name="Man Power"
                value="not available"
                >Not Available</b-form-radio
              >
              <span
                class="text-sm text-danger"
                v-show="errors.has('Man Power')"
                >{{ errors.first("Man Power") }}</span
              >
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold"
              >Budget <span class="text-danger">*</span></label
            >
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="bodyVerifSPG.resource_availability.budget"
                v-validate="'required'"
                :aria-describedby="ariaDescribedby"
                name="Budget"
                value="available"
                >Available</b-form-radio
              >
              <b-form-radio
                v-model="bodyVerifSPG.resource_availability.budget"
                v-validate="'required'"
                :aria-describedby="ariaDescribedby"
                name="Budget"
                value="not available"
                >Not Available</b-form-radio
              >
              <span class="text-sm text-danger" v-show="errors.has('Budget')">{{
                errors.first("Budget")
              }}</span>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold"
              >High Depedency with Existing Solution
              <span class="text-danger">*</span></label
            >
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="bodyVerifSPG.high_dependency"
                v-validate="'required'"
                :aria-describedby="ariaDescribedby"
                name="High Depedency"
                value="yes"
                >Yes</b-form-radio
              >
              <b-form-radio
                v-model="bodyVerifSPG.high_dependency"
                v-validate="'required'"
                :aria-describedby="ariaDescribedby"
                name="High Depedency"
                value="no"
                >No</b-form-radio
              >
              <span
                class="text-sm text-danger"
                v-show="errors.has('High Depedency')"
                >{{ errors.first("High Depedency") }}</span
              >
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <label class="font-weight-bold"
              >Estimated Time Delivery <span class="text-danger">*</span></label
            >
            <div class="row">
              <div class="col-lg-4">
                <v-select
                  v-model="bodyVerifSPG.estimated_time_delivery_spg.week"
                  :options="['Week 1', 'Week 2', 'Week 3', 'Week 4']"
                  name="Estimated Time Delivery"
                  v-validate="'required'"
                  placeholder="Select Week"
                ></v-select>
              </div>
              <div class="col-lg-4">
                <v-select
                  v-model="bodyVerifSPG.estimated_time_delivery_spg.month"
                  :options="[
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                  ]"
                  name="Estimated Time Delivery"
                  v-validate="'required'"
                  placeholder="Select Month"
                ></v-select>
              </div>
              <div class="col-lg-4">
                <v-select
                  v-model="bodyVerifSPG.estimated_time_delivery_spg.year"
                  :options="
                    Array.from({ length: 5 }, (_, i) => {
                      const currentYear = new Date().getFullYear();
                      const year = currentYear + i;
                      return `${year}`;
                    })
                  "
                  name="Estimated Time Delivery"
                  v-validate="'required'"
                  placeholder="Select Year"
                />
              </div>
            </div>
            <span
              class="text-sm text-danger"
              v-show="errors.has('Estimated Time Delivery')"
              >{{ errors.first("Estimated Time Delivery") }}</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label>Time Delivery <span class="text-danger">*</span></label>
            <v-select
              v-model="bodyVerifSPG.time_delivery_spg.value"
              :options="['1-3 Month', '3-6 Month', '6-9 Month', '9-12 Month']"
              name="Time Delivery"
              v-validate="'required'"
            ></v-select>
            <span
              class="text-sm text-danger"
              v-show="errors.has('Time Delivery')"
              >{{ errors.first("Time Delivery") }}</span
            >
          </div>
          <div class="col-lg-6">
            <label>Notes</label>
            <textarea
              v-model="bodyVerifSPG.time_delivery_spg.notes"
              class="form-control"
            ></textarea>
          </div>
        </div>
        <div class="float-end mt-3">
          <div v-if="isLoading == false">
            <b-button
              class="mr-2"
              variant="warning"
              @click="submitVerifSPG('draft')"
              >Save as Draft</b-button
            >
            <b-button variant="primary" @click="submitVerifSPG('submit')"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
      <div v-else>
        <div class="form-group">
          <label>Notes</label>
          <textarea class="form-control" v-model="bodyNotes.notes" />
        </div>
        <div class="float-end mt-3">
          <b-button
            v-if="isLoading == false"
            variant="primary"
            @click="rejectSPG"
            >Submit</b-button
          >
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-spg-kickoff"
      hide-footer
      size="lg"
      title="Kickoff Project Notes Form"
      @hide="onHide"
    >
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" v-model="bodyNotes.notes" />
      </div>
      <div class="float-end">
        <div v-if="isLoading == false">
          <div v-if="typeAction == 'verif'">
            <b-button
              class="mr-2"
              variant="warning"
              @click="submitKickoffSpg('draft')"
              >Save as Draft</b-button
            >
            <b-button variant="primary" @click="submitKickoffSpg('submit')"
              >Submit</b-button
            >
          </div>
          <div v-else>
            <b-button variant="primary" @click="submitKickoffSpg('revision')"
              >Submit</b-button
            >
          </div>
        </div>
        <button
          v-else
          style="margin-left: auto; float: right"
          class="mt-4 btn btn-primary"
          type="button"
          disabled
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-project-development-difo"
      hide-footer
      size="xl"
      title="Project Development Form"
      @hide="onHide"
    >
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Modul</div>
          <b-button
            variant="primary"
            class="ml-2 mr-2"
            size="sm"
            @click="newModule"
          >
            <span class="fe fe-plus"></span>
            New Module
          </b-button>
        </div>
        <div class="card-body" style="max-height: 600px; overflow-y: auto">
          <div v-for="(item, index) in bodyDevDIFO.module" :key="index">
            <hr v-if="index > 0" class="my-3" />

            <div class="row">
              <div class="form-group col-lg-10">
                <label class="form-label">Modul {{ index + 1 }}</label>
                <input type="text" class="form-control" v-model="item.name" />
              </div>
              <div class="col-lg-1 d-flex align-items-center">
                <a
                  href="#!"
                  class="btn btn-sm btn-primary"
                  @click="addFeature(index)"
                >
                  <span class="fe fe-plus"></span>Feature
                </a>
              </div>
              <div class="col-lg-1 d-flex align-items-center">
                <a
                  href="#!"
                  class="btn btn-sm btn-danger"
                  @click="removeModule(index)"
                >
                  <span class="fe fe-trash"></span>
                </a>
              </div>
            </div>

            <div
              v-for="(feature, fIndex) in item.feature"
              :key="fIndex"
              class="row mt-2"
            >
              <div class="form-group col-lg-11">
                <label class="form-label">Feature {{ fIndex + 1 }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="item.feature[fIndex]"
                />
              </div>
              <div class="col-lg-1 d-flex align-items-center">
                <a
                  href="#!"
                  class="btn btn-sm btn-danger"
                  @click="removeFeature(index, fIndex)"
                >
                  <span class="fe fe-trash"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group mt-3">
        <label>Notes</label>
        <textarea class="form-control" v-model="bodyNotes.notes"></textarea>
      </div>
      <div class="float-end">
        <div v-if="isLoading == false">
          <b-button variant="primary" @click="submitProjectDevelopment()"
            >Submit</b-button
          >
        </div>
        <button
          v-else
          style="margin-left: auto; float: right"
          class="mt-4 btn btn-primary"
          type="button"
          disabled
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-development"
      hide-footer
      size="xl"
      :title="
        typeAction === 'pra_golive'
          ? 'Pra Go Live Form'
          : typeAction === 'golive'
          ? 'Go Live Form'
          : typeAction === 'monitoring'
          ? 'Monitoring Form'
          : 'Default Title'
      "
      @hide="onHide"
    >
      <div v-if="typeAction == 'pra_golive'">
        <div class="d-flex justify-content-between align-items-center">
          <h3>Pra Go Live Gathering of SPG</h3>
          <b-button variant="primary" class="ml-auto" @click="addNewLink">
            <span class="fe fe-plus"></span> Add
          </b-button>
        </div>
        <div style="max-height: 600px !important; overflow-x: scroll">
          <div
            class="row mt-3"
            v-for="(item, index) in bodyVerifDP"
            :key="index"
          >
            <div class="col-lg-3">
              <div class="form-group">
                <label
                  >Title
                  <span class="text-danger" v-if="index <= 3">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.title"
                  :name="`Title-${index}`"
                  v-validate="index <= 3 ? 'required' : ''"
                  :disabled="index <= 3"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has(`Title-${index}`)"
                  >{{ errors.first(`Title-${index}`) }}</span
                >
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group">
                <label
                  >Shortlink
                  <span class="text-danger" v-if="index <= 3">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.link"
                  :name="`Shortlink-${index}`"
                  v-validate="index <= 3 ? 'required' : ''"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has(`Shortlink-${index}`)"
                  >{{ errors.first(`Shortlink-${index}`) }}</span
                >
              </div>
            </div>
            <div class="col-lg-5">
              <div class="form-group">
                <label>Reason </label>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="item.notes"
                />
              </div>
            </div>
            <div class="col-lg-1" v-if="index > 3">
              <b-button
                variant="primary"
                class="float-end mt-5"
                @click="clearFormVerifDP(index)"
                ><span class="fe fe-trash"></span
              ></b-button>
            </div>
          </div>
        </div>
        <div class="float-end">
          <div v-if="isLoading == false">
            <b-button variant="primary" @click="submitPraGolive()"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
      <div v-if="typeAction == 'golive'">
        <div class="form-group mt-3">
          <label>Notes</label>
          <textarea class="form-control" v-model="bodyNotes.notes"></textarea>
        </div>
        <div class="float-end">
          <div v-if="isLoading == false">
            <b-button variant="primary" @click="submitGolive()"
              >Go Live</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
      <div v-if="typeAction == 'monitoring'">
        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Month 1</h3>
            <b-button
              variant="primary"
              class="ml-auto"
              @click="addNewLinkMonitoring('month_1')"
            >
              <span class="fe fe-plus"></span> Add
            </b-button>
          </div>
          <div
            class="card mt-2"
            v-for="(item, index) in bodyVerifDP.month_1"
            :key="index"
          >
            <div class="card-header">
              <div class="card-header-tittle">Rate {{ index + 1 }}</div>
              <b-button
                variant="primary"
                v-if="index > 0"
                class="ms-2 d-flex align-items-center justify-content-center"
                style="height: 38px"
                @click="clearFormVerifDP(index, 'month_1')"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Adoption Rate <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.adoption_rate"
                      :name="`Adoption Rate-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Adoption Rate-${index}`)"
                      >{{ errors.first(`Adoption Rate-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Benefit Realization
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.benefit_realization"
                      :name="`Benefit Realization-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Benefit Realization-${index}`)"
                      >{{ errors.first(`Benefit Realization-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Adoption</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_adoption"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Benefit</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_benefit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Month 2</h3>
            <b-button
              variant="primary"
              class="ml-auto"
              @click="addNewLinkMonitoring('month_2')"
            >
              <span class="fe fe-plus"></span> Add
            </b-button>
          </div>
          <div
            class="card mt-2"
            v-for="(item, index) in bodyVerifDP.month_2"
            :key="index"
          >
            <div class="card-header">
              <div class="card-header-tittle">Rate {{ index + 1 }}</div>
              <b-button
                variant="primary"
                v-if="index > 0"
                class="ms-2 d-flex align-items-center justify-content-center"
                style="height: 38px"
                @click="clearFormVerifDP(index, 'month_2')"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Adoption Rate <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.adoption_rate"
                      :name="`Adoption Rate-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Adoption Rate-${index}`)"
                      >{{ errors.first(`Adoption Rate-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Benefit Realization
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.benefit_realization"
                      :name="`Benefit Realization-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Benefit Realization-${index}`)"
                      >{{ errors.first(`Benefit Realization-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Adoption</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_adoption"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Benefit</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_benefit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Month 3</h3>
            <b-button
              variant="primary"
              class="ml-auto"
              @click="addNewLinkMonitoring('month_3')"
            >
              <span class="fe fe-plus"></span> Add
            </b-button>
          </div>
          <div
            class="card mt-2"
            v-for="(item, index) in bodyVerifDP.month_3"
            :key="index"
          >
            <div class="card-header">
              <div class="card-header-tittle">Rate {{ index + 1 }}</div>
              <b-button
                variant="primary"
                v-if="index > 0"
                class="ms-2 d-flex align-items-center justify-content-center"
                style="height: 38px"
                @click="clearFormVerifDP(index, 'month_3')"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Adoption Rate <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.adoption_rate"
                      :name="`Adoption Rate-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Adoption Rate-${index}`)"
                      >{{ errors.first(`Adoption Rate-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Benefit Realization
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.benefit_realization"
                      :name="`Benefit Realization-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Benefit Realization-${index}`)"
                      >{{ errors.first(`Benefit Realization-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Adoption</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_adoption"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Benefit</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_benefit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="float-end mt-3">
          <div v-if="isLoading == false">
            <b-button variant="primary" @click="submitMonitoring()"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-detail-development"
      hide-footer
      size="xl"
      title="Detail Development"
    >
      <b-tabs v-if="dataDetails">
        <b-tab title="DIFO Project Development">
          <div class="row mt-3">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold"
                  >Project Development Request By</label
                >
                <p>{{ dataDetails.project_development_difo }}</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold">Realese Initiate</label>
                <p>
                  {{
                    Array.isArray(details.project_development_flow)
                      ? "Partial Release"
                      : "Full Release"
                  }}
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold">Module</label>
                <p>{{ dataDetails.module_name }}</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold">Feature</label>
                <ul class="ps-3 mb-0">
                  <li
                    v-for="(feature, index) in dataDetails.feature"
                    :key="index"
                  >
                    {{ feature }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col ms-n2">
                    <!-- Title -->
                    <h4 class="mb-1 font-weight-bold">Notes</h4>

                    <!-- Text -->
                    <p class="text-body-secondary mb-1">
                      {{ dataDetails.notes }}
                    </p>
                  </div>
                </div>
                <!-- / .row -->
              </div>
              <!-- / .card-body -->
            </div>
          </div>
        </b-tab>
        <b-tab title="SPG Pra Go Live" v-if="dataDetails.pra_go_live_flow">
          <div class="form-group">
            <label class="font-weight-bold">Pra Go Live by</label>
            <p>{{ dataDetails.pra_go_live_flow.fullname }}</p>
          </div>
          <div class="row mt-5">
            <div
              class="col-lg-3"
              v-for="(item, index) in dataDetails.pra_go_live_flow.gathering"
              :key="index"
            >
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col ms-n2">
                      <!-- Title -->
                      <h4 class="mb-1 font-weight-bold">
                        {{ item.title }}
                      </h4>

                      <!-- Text -->
                      <p class="small text-body-secondary mb-1">
                        Link :
                        <b-link @click="functionLink(item.link)">
                          {{
                            item.link.length > 20
                              ? item.link.slice(0, 20) + "..."
                              : item.link
                          }}
                        </b-link>
                      </p>

                      <!-- Status -->
                      <p class="small mb-0">
                        Notes :
                        <span class="text-muted">{{
                          item.notes ? item.notes : "-"
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <!-- / .row -->
                </div>
                <!-- / .card-body -->
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="SPG Go Live" v-if="dataDetails.go_live_flow">
          <div class="form-group">
            <label class="font-weight-bold">Go Live by</label>
            <p>{{ dataDetails.go_live_flow.fullname }}</p>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col ms-n2">
                  <!-- Title -->
                  <h4 class="mb-1 font-weight-bold">Go Live Notes</h4>

                  <!-- Text -->
                  <p class="small text-body-secondary mb-1">
                    {{ dataDetails.go_live_flow.notes }}
                  </p>
                </div>
              </div>
              <!-- / .row -->
            </div>
            <!-- / .card-body -->
          </div>
        </b-tab>
        <b-tab
          title="Demand Touchpoint Monitoring"
          v-if="dataDetails.monitoring_flow"
        >
          <div class="form-group">
            <label class="font-weight-bold">Monitoring by</label>
            <p>{{ dataDetails.monitoring_flow.fullname }}</p>
          </div>

          <b-tabs>
            <b-tab title="Month 1">
              <div
                class="card mt-2"
                v-for="(item, index) in dataDetails.monitoring_flow
                  .adoption_rate.month_1"
                :key="index"
              >
                <div class="card-header">
                  <div class="card-header-tittle">Rate {{ index + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Adoption Rate</label>
                        <p v-html="checkLink(item.adoption_rate)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Benefit Realization</label
                        >
                        <p v-html="checkLink(item.benefit_realization)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Adoption</label>
                        <p>{{ item.notes_adoption }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Benefit</label>
                        <p>{{ item.notes_benefit }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Month 2">
              <div
                class="card mt-2"
                v-for="(item, index) in dataDetails.monitoring_flow
                  .adoption_rate.month_2"
                :key="index"
              >
                <div class="card-header">
                  <div class="card-header-tittle">Rate {{ index + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Adoption Rate</label>
                        <p v-html="checkLink(item.adoption_rate)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Benefit Realization</label
                        >
                        <p v-html="checkLink(item.benefit_realization)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Adoption</label>
                        <p>{{ item.notes_adoption }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Benefit</label>
                        <p>{{ item.notes_benefit }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Month 3">
              <div
                class="card mt-2"
                v-for="(item, index) in dataDetails.monitoring_flow
                  .adoption_rate.month_3"
                :key="index"
              >
                <div class="card-header">
                  <div class="card-header-tittle">Rate {{ index + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Adoption Rate</label>
                        <p v-html="checkLink(item.adoption_rate)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Benefit Realization</label
                        >
                        <p v-html="checkLink(item.benefit_realization)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Adoption</label>
                        <p>{{ item.notes_adoption }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Benefit</label>
                        <p>{{ item.notes_benefit }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
    </b-modal>

    <ModalNotification
      @show-modal="showModalNotification"
      @hide-modal="hideModalNotification"
      ref="modalNotification"
      :type="notificationType"
      :recipientsRequestor="notificationRecipientsRequestor"
      :recipientsGG="notificationRecipientsGG"
      :cc="notificationCc"
      :ideationId="ideationId"
      :ideationName="details?.overview?.name"
      :ideationDate="details?.overview?.date"
    />
  </div>
</template>

<script>
import moment from "moment";
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon,
} from "vue-simple-accordion";
import { props } from "vue2-dropzone";
import ModalNotification from "@/components/ideation/ModalNotification.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Ideation",
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    ModalNotification,
  },
  computed: {
    details() {
      return this.$store.getters["ideation/detailIdeation"]
        ? this.$store.getters["ideation/detailIdeation"]
        : [];
    },
    flows() {
      return this.$store.getters["ideation/flowIdeation"]
        ? this.$store.getters["ideation/flowIdeation"]
        : [];
    },
    paginatedHoldItems() {
      return (type) => {
        const items = this.getHoldItems(this.details.hold, type);
        const start = (this.currentPage[type] - 1) * this.itemsPerPage;
        return items.slice(start, start + this.itemsPerPage);
      };
    },
    totalPages() {
      return (type) => {
        return Math.ceil(
          this.getHoldItems(this.details.hold, type).length / this.itemsPerPage
        );
      };
    },
    totalHoldItems() {
      return this.getHoldItems(this.details.hold, "Hold").length;
    },
    totalUnholdItems() {
      return this.getHoldItems(this.details.hold, "Unhold").length;
    },
  },
  data() {
    return {
      currentPage: {
        Hold: 1,
        Unhold: 1,
      },
      itemsPerPage: 10,
      isLoading: false,
      isAdd: false,
      tabIndex: 1,
      isFlow: "",
      idIdeation: "",
      acknowledgeCount: 0,
      notificationType: "acknowledge",
      notificationRecipientsRequestor: [],
      notificationRecipientsGG: [],
      notificationCc: [],
      show: false,
      dataDetails: {},
      roles: "",
      ideationId: "",
      moduleId: "",
      typeAction: "",
      bodyNotes: {
        notes: "",
      },
      bodyVerifDP: [],
      bodyVerifSPG: {
        resource_availability: {
          man_power: "",
          budget: "",
        },
        high_dependency: "",
        time_delivery_spg: {
          value: "",
          notes: "",
        },
        estimated_time_delivery_spg: {
          week: "",
          month: "",
          year: "",
        },
      },
      columns: [
        {
          label: "Timestamp",
          field: "created_at",
        },
        {
          label: "Action Type",
          field: "action_type",
        },
        {
          label: "Action by",
          field: "action_by",
        },
        {
          label: "Action To",
          field: "action_to",
        },
        {
          label: "Scope",
          field: "scope",
        },
        {
          label: "Status",
          field: "status",
        },
      ],
      columnsModule: [
        {
          label: "Module Name",
          field: "module_name",
        },
        {
          label: "Timestamp",
          field: "created_at",
        },
        {
          label: "Action Type",
          field: "action_type",
        },
        {
          label: "Action by",
          field: "action_by",
        },
        {
          label: "Action To",
          field: "action_to",
        },
        {
          label: "Scope",
          field: "scope",
        },
        {
          label: "Status",
          field: "status",
        },
      ],
      columnsRealese: [
        {
          label: "Modul",
          field: "modul",
        },
        {
          label: "Feature",
          field: "feature",
        },
        {
          label: "Latest Status",
          field: "latest_status",
        },
      ],
      rowsDummy: [
        {
          modul: "Modul 1",
          feature: "Feature 1",
          latest_status: "Review Pra GoLive by SPG",
        },
        {
          modul: "Modul 1",
          feature: "Feature 1",
          latest_status: "Review Pra GoLive by SPG",
        },
        {
          modul: "Modul 1",
          feature: "Feature 1",
          latest_status: "Review Pra GoLive by SPG",
        },
      ],
      bodyDevDIFO: {
        module: [],
      },
      columnsProjectDevelopment: [
        {
          label: "Module",
          field: "module_name",
        },
        {
          label: "Feature",
          field: "feature",
        },
        {
          label: "Latest Status",
          field: "status",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
        },
      ],
      // module: {
      //     name: '',
      //     feature: []
      // }
    };
  },

  mounted() {
    this.roles = localStorage.getItem("role_map");
    this.getDetail();
  },
  methods: {
    getDetail() {
      const pathname = window.location.pathname;
      const segments = pathname.split("/");
      const ideationId = segments[segments.length - 1];
      this.ideationId = ideationId;
      this.show = true;
      if (ideationId) {
        this.$store
          .dispatch("ideation/GET_IDEATION_DETAIL", {
            id: ideationId,
          })
          .then(() => {
            this.$store
              .dispatch("ideation/GET_IDEATION_FLOW", {
                id: ideationId,
              })
              .then((resp) => {
                this.show = false;
              });
          });
      }
    },

    // special case for demand touchpoint
    showModalNotification(type) {
      this.notificationType = type;

      this.getUserEmailByIdeation(this.ideationId);
      this.getUserEmailByRole().then(() => {
        setTimeout(() => {
          this.$bvModal.show("modal-notification");
        }, 500);
      });
    },

    async hideModalNotification() {
      this.$bvModal.hide("modal-notification");

      //   for refresh data acknowledge count nya
      await this.$store.dispatch("ideation/GET_IDEATION_BYID", {
        id: this.ideationId,
      });
    },

    async getUserEmailByRole() {
      const response = await this.$store.dispatch(
        "userData/GET_ALL_USERS_BYROLE",
        {
          role: "Demand Touchpoint",
        }
      );
      const emails = response?.map((item) => item.email) || [];
      this.notificationCc.push(...emails);
    },

    async getUserEmailByIdeation(ideationId) {
      const response = await this.$store.dispatch(
        "ideation/GET_IDEATION_BYID",
        {
          id: ideationId,
        }
      );
      const requestorEmail = response?.overview?.requestor?.email;
      if (requestorEmail)
        this.notificationRecipientsRequestor.push(requestorEmail);

      const ggEmail = response?.genta_gendis_flow?.email;
      if (ggEmail) this.notificationRecipientsGG.push(ggEmail);
    },

    backgroundList(data) {
      const slicedBackground = data?.slice(0, 4);
      return slicedBackground?.filter((item) => item.selected);
    },
    benefitList(data) {
      return data?.filter((item) => item.selected);
    },
    statusFlow(status) {
      if (status == "On Review" || status == "Hold") {
        return "bg-info-soft";
      } else if (status == "Verified") {
        return "bg-success-soft";
      } else if (status == "Revision") {
        return "bg-warning-soft";
      } else {
        return "bg-danger-soft";
      }
    },
    convertTime(timestamp) {
      if (timestamp) {
        return moment(timestamp).format("DD/MM/YYYY HH:mm:ss");
      } else {
        return "-";
      }
    },
    convertTimeline(timestamp) {
      if (timestamp) {
        return moment(timestamp).fromNow();
      } else {
        return "-";
      }
    },
    convertDate(str) {
      if (str) {
        return moment(str).format("ddd, DD MMM YYYY");
      } else {
        return "-";
      }
    },
    convertDateDetail(str) {
      if (str) {
        return moment(str).format("dddd, DD MMM YYYY HH:mm:ss");
      } else {
        return "-";
      }
    },
    splitText(text) {
      if (!text) return [];

      // If text exceeds 50 characters, truncate and add "..."
      if (text.length > 50) {
        text = text.substring(0, 50) + "...";
      }

      // Split into lines every 30 characters
      return text.match(/.{1,30}/g);
    },
    getCreatedStatus(item, index, module) {
      if (!module && index >= 8 && index <= 12 && this.flows?.[7]?.created_at) {
        return "On Review";
      }

      if (item?.flow) {
        return "Revision";
      }

      if (index === 0) {
        return item?.created_at ? "Verified" : "On Review";
      }

      if (item?.created_at) {
        return "Verified";
      }

      if (index > 0 && this.flows?.[index - 1]?.created_at) {
        return "On Review";
      }

      return "";
    },

    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
      if (evt.trigger === "headerclose") {
        evt.preventDefault();
        this.$swal({
          title: "Confirm Close?",
          text: "Are you sure want to close this page?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00D97E",
          cancelButtonColor: "#E63757",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$bvModal.hide("modal-genta-gendis");
            this.bodyNotes.notes = "";

            this.$bvModal.hide("modal-demand-touchpoint");
            this.bodyVerifDP = [
              {
                title: "Business Requirement",
                link: "",
                notes: "",
              },
              {
                title: "Involved Roles",
                link: "",
                notes: "",
              },
              {
                title: "Business Success Criteria",
                link: "",
                notes: "",
              },
              {
                title: "References Tech",
                link: "",
                notes: "",
              },
            ];
            this.bodyDevDIFO.module = [];

            this.$bvModal.hide("modal-verif-spg");
            this.$bvModal.hide("modal-spg-kickoff");
            this.$bvModal.hide("modal-project-development-difo");
            this.$bvModal.hide("modal-development");
          }
        });
      }
    },
    sortRevisions(data) {
      return data
        .slice()
        .sort((a, b) => new Date(a?.created_at) - new Date(b?.created_at));
    },

    // Role
    isGentaGendisRole(status) {
      if (this.roles == "Genta Gendis" || this.roles == "Super Admin") {
        if (
          status == "Review By Genta Gendis" ||
          status == "Request Revision to Genta Gendis"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isDemandTouchpointRole(status) {
      if (this.roles == "Demand Touchpoint" || this.roles == "Super Admin") {
        if (
          status == "Review By Demand Touch Point" ||
          status == "Request Revision to Demand Touch Point"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isSpgVerifRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (
          status == "Review By SPG" ||
          status == "Hold By SPG" ||
          status == "Unhold By SPG" ||
          status == "Request Revision to SPG"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isDemandSolutionRole(status) {
      if (this.roles == "Demand Solution" || this.roles == "Super Admin") {
        if (
          status == "Review By Demand Solution" ||
          status == "Request Revision to Demand Solution"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isDifoRole(status) {
      if (this.roles == "DIFO" || this.roles == "Super Admin") {
        if (
          status == "Review By DIFO" ||
          status == "Request Revision to DIFO"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isSpgFinalizationRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (
          status == "Review Finalization By SPG" ||
          status == "Request Revision Finalization to SPG"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isSpgKickoffRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (status == "Review Kick Off By SPG") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isProjectDevelopmentDifo(status, module) {
      if (this.roles == "DIFO" || this.roles == "Super Admin") {
        if (
          status == "Review Project Development By DIFO" ||
          (status == "Partial Release By Digitech" && module == false)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isPragoliveRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (status == "Review Pra Go Live By SPG") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isGoLiveRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (status == "Review Go Live By SPG") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isMonitoringFlow(status) {
      if (this.roles == "Demand Touchpoint" || this.roles == "Super Admin") {
        if (status == "Review Monitoring By Demand Touch Point") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // Action in Genta Gendis
    openModalGG(type) {
      this.$store
        .dispatch("ideation/GET_LIST_IDEATION_DRAFT", this.ideationId)
        .then((resp) => {
          let draftData = this.$store.getters["ideation/notesDraft"];
          if (type == "verif") {
            this.bodyNotes.notes = draftData.notes;
          } else {
            this.bodyNotes.notes = "";
          }
          this.$bvModal.show("modal-genta-gendis");
          this.typeAction = type;
        });
    },
    submitVerifGG(typeSave) {
      this.$swal({
        title: `Confirm ${typeSave}?`,
        text: `Are you sure want to ${typeSave} this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          if (this.typeAction == "verif") {
            if (typeSave == "submit") {
              this.$store
                .dispatch("ideation/VERIFIED_BY_GENTA_GENDIS", {
                  id: this.ideationId,
                  notes: this.bodyNotes,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.$router.push({
                      name: "Ideation",
                    });
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } else {
              this.$store
                .dispatch("ideation/VERIFIED_BY_GENTA_GENDIS_DRAFT", {
                  id: this.ideationId,
                  notes: this.bodyNotes,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved as draft",
                    "success"
                  ).then(() => {
                    this.$router.push({
                      name: "Ideation",
                    });
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            }
          } else {
            this.$store
              .dispatch("ideation/REVISION_BY_GENTA_GENDIS", {
                id: this.ideationId,
                notes: this.bodyNotes,
              })
              .then(() => {
                this.isLoading = false;
                this.$swal(
                  "Saved",
                  "Your input has been saved",
                  "success"
                ).then(() => {
                  this.$router.push({
                    name: "Ideation",
                  });
                });
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal("Error", `${err.response.data.error}`, "error");
              });
          }
        }
      });
    },

    // action role Demand Touchpoint
    openModalDp(type) {
      this.$store
        .dispatch("ideation/GET_LIST_DRAFT_NOTES_DEMAND", this.ideationId)
        .then((resp) => {
          let draftData = this.$store.getters["ideation/notesDraft"];
          this.$bvModal.show("modal-demand-touchpoint");
          this.typeAction = type;
          this.isFlow = "Final Requirement Document";
          if (draftData.final_requirement_document) {
            this.bodyVerifDP = draftData.final_requirement_document;
          } else {
            this.bodyVerifDP = [
              {
                title: "Business Requirement",
                link: "",
                notes: "",
              },
              {
                title: "Involved Roles",
                link: "",
                notes: "",
              },
              {
                title: "Business Success Criteria",
                link: "",
                notes: "",
              },
              {
                title: "References Tech",
                link: "",
                notes: "",
              },
            ];
          }
        });
    },
    addNewLink() {
      const bodys = {
        title: "",
        link: "",
        notes: "",
      };
      this.bodyVerifDP.push(bodys);
    },
    addNewLinkMonitoring(month) {
      const bodys = {
        adoption_rate: "",
        benefit_realization: "",
        notes_adoption: "",
        notes_benefit: "",
      };
      if (month == "month_1") {
        this.bodyVerifDP.month_1.push(bodys);
      } else if (month == "month_2") {
        this.bodyVerifDP.month_2.push(bodys);
      } else if (month == "month_3") {
        this.bodyVerifDP.month_3.push(bodys);
      }
    },
    clearFormVerifDP(index, type) {
      if (type == "month_1") {
        this.bodyVerifDP.month_1.splice(index, 1);
      } else if (type == "month_2") {
        this.bodyVerifDP.month_2.splice(index, 1);
      } else if (type == "month_3") {
        this.bodyVerifDP.month_3.splice(index, 1);
      } else {
        this.bodyVerifDP.splice(index, 1);
      }
    },
    submitVerifDemandTouchpoint(logs, saveStatus) {
      if (saveStatus !== "submit") {
        return this.handleSubmitVerif(logs, saveStatus);
      }

      this.$validator
        .validateAll()
        .then(async (res) => {
          if (!res) return false;
          this.handleSubmitVerif(logs, saveStatus);
        })
        .catch(() => {
          this.$swal("Error", this.$t("Error while adding data"), "error");
        });
    },

    handleSubmitVerif(logs, saveStatus) {
      this.$swal({
        title: `Confirm ${saveStatus}?`,
        text: `Are you sure want to ${saveStatus} this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          let action = "";

          if (logs === "High Level Spesification Design") {
            action =
              saveStatus === "submit"
                ? "ideation/VERIFIED_DEMAND_SOLUTION"
                : "ideation/VERIFIED_BY_DEMAND_SOLUTION_DRAFT";
          } else if (logs === "Final Requirement Document") {
            action =
              saveStatus === "submit"
                ? "ideation/VERIFIED_DEMAND_TOUCHPOINT"
                : "ideation/VERIFIED_BY_DEMAND_TOUCHPOINT_DRAFT";
          } else if (logs === "Technical Spesification Design (TSD)") {
            action =
              saveStatus === "submit"
                ? "ideation/VERIFIED_DIFO"
                : "ideation/VERIFIED_DIFO_DRAFT";
          } else if (logs === "Requirement Boarding of SPG") {
            action =
              saveStatus === "submit"
                ? "ideation/FINALIZATION_SPG"
                : "ideation/FINALIZATION_BY_SPG_DRAFT";
          }

          if (action) {
            this.$store
              .dispatch(action, {
                id: this.ideationId,
                bodys: this.bodyVerifDP,
              })
              .then(() => {
                this.isLoading = false;
                this.$swal(
                  "Saved",
                  `Your input has been saved ${
                    saveStatus === "draft" ? "as draft" : ""
                  }`,
                  "success"
                ).then(() => {
                  this.$router.push({
                    name: "Ideation",
                  });
                });
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal("Error", `${err.response.data.error}`, "error");
              });
          }
        }
      });
    },
    revisionDemandTouchpoint() {
      this.isLoading = true;
      this.$store
        .dispatch("ideation/REVISION_DEMAND_TOUCHPOINT", {
          id: this.ideationId,
          notes: this.bodyNotes,
        })
        .then(() => {
          this.isLoading = false;
          this.$swal("Saved", "Your input has been saved", "success").then(
            () => {
              this.$router.push({
                name: "Ideation",
              });
            }
          );
        })
        .catch((err) => {
          this.isLoading = false;
          this.$swal("Error", `${err.response.data.error}`, "error");
        });
    },

    // action role Verif SPG
    openModalVerifSpg(type) {
      this.$store
        .dispatch("ideation/GET_SPG_DRAFT", this.ideationId)
        .then(() => {
          let datas = this.$store.getters["ideation/notesDraft"];
          this.$bvModal.show("modal-verif-spg");
          this.typeAction = type;
          this.bodyVerifSPG = {
            resource_availability: {
              man_power: datas.resource_availability
                ? datas.resource_availability.man_power
                : "",
              budget: datas.resource_availability
                ? datas.resource_availability.budget
                : "",
            },
            high_dependency: datas.high_dependency ? datas.high_dependency : "",
            time_delivery_spg: {
              value: datas.time_delivery_spg
                ? datas.time_delivery_spg.value
                : "",
              notes: datas.time_delivery_spg
                ? datas.time_delivery_spg.notes
                : "",
            },
            estimated_time_delivery_spg: {
              week: datas?.estimated_time_delivery_spg?.week,
              month: datas?.estimated_time_delivery_spg?.month,
              year: datas?.estimated_time_delivery_spg?.year,
            },
          };
        });
    },
    submitVerifSPG(saveStatus) {
      this.$swal({
        title: `Confirm ${saveStatus}?`,
        text: `Are you sure want to ${saveStatus} this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          if (saveStatus == "submit") {
            this.$validator.validateAll().then(async (res) => {
              if (!res) return false;
              try {
                this.$store
                  .dispatch("ideation/VERIFICATION_BY_SPG", {
                    id: this.ideationId,
                    body: this.bodyVerifSPG,
                  })
                  .then(() => {
                    this.isLoading = false;
                    this.$swal(
                      "Saved",
                      "Your input has been saved",
                      "success"
                    ).then(() => {
                      this.$router.push({
                        name: "Ideation",
                      });
                    });
                  })
                  .catch((err) => {
                    this.isLoading = false;
                    this.$swal("Error", `${err.response.data.error}`, "error");
                  });
              } catch (resp) {
                this.$swal("Error", this.$t("Error while add data"), "error");
              }
            });
          } else {
            this.$store
              .dispatch("ideation/VERIFICATION_BY_SPG_DRAFT", {
                id: this.ideationId,
                body: this.bodyVerifSPG,
              })
              .then(() => {
                this.isLoading = false;
                this.$swal(
                  "Saved",
                  "Your input has been saved to draft",
                  "success"
                ).then(() => {
                  this.$router.push({
                    name: "Ideation",
                  });
                });
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal("Error", `${err.response.data.error}`, "error");
              });
          }
        }
      });
    },
    rejectSPG() {
      console.log(this.typeAction);
      if (this.typeAction == "revision") {
        this.isLoading = true;
        this.$store
          .dispatch("ideation/REVISION_BY_SPG", {
            id: this.ideationId,
            notes: this.bodyNotes,
          })
          .then(() => {
            this.isLoading = false;
            this.$swal("Saved", "Your input has been saved", "success").then(
              () => {
                this.$router.push({
                  name: "Ideation",
                });
              }
            );
          })
          .catch((err) => {
            this.isLoading = false;
            this.$swal("Error", `${err.response.data.error}`, "error");
          });
      } else if (this.typeAction == "reject") {
        this.isLoading = true;
        this.$store
          .dispatch("ideation/REJECT_BY_SPG", {
            id: this.ideationId,
            notes: this.bodyNotes,
          })
          .then(() => {
            this.isLoading = false;
            this.$swal("Saved", "Your input has been saved", "success").then(
              () => {
                this.$router.push({
                  name: "Ideation",
                });
              }
            );
          })
          .catch((err) => {
            this.isLoading = false;
            this.$swal("Error", `${err.response.data.error}`, "error");
          });
      } else if (this.typeAction == "Hold" || this.typeAction == "Unhold") {
        this.holdIdeation(this.typeAction);
      }
    },
    holdIdeation(status) {
      this.isLoading = true;
      this.$store
        .dispatch("ideation/HOLD_BY_SPG", {
          id: this.ideationId,
          status: status,
          notes: this.bodyNotes,
        })
        .then(() => {
          this.isLoading = false;
          this.$swal("Saved", "Your input has been saved", "success").then(
            () => {
              this.$router.push({
                name: "Ideation",
              });
            }
          );
        })
        .catch((err) => {
          this.isLoading = false;
          this.$swal("Error", `${err.response.data.error}`, "error");
        });
    },

    // Action Role Demand Solution
    openModalDs(type) {
      this.$store
        .dispatch("ideation/GET_DRAFT_DEMAND_SOLUTION", this.ideationId)
        .then(() => {
          this.$bvModal.show("modal-demand-touchpoint");
          (this.typeAction = type),
            (this.isFlow = "High Level Spesification Design");
          let datas =
            this.$store.getters["ideation/notesDraft"].high_level_spesification;
          if (datas) {
            this.bodyVerifDP = datas;
          } else {
            this.bodyVerifDP = [
              {
                title: "Flowchart",
                link: "",
                notes: "",
              },
              {
                title: "Uses Cases Diagram & Roles",
                link: "",
                notes: "",
              },
              {
                title: "Wireframe/MockUp",
                link: "",
                notes: "",
              },
              {
                title: "Test Scenario",
                link: "",
                notes: "",
              },
              {
                title: "Non-Fuctional Requirement",
                link: "",
                notes: "",
              },
              {
                title: "Solution Option Assesment",
                link: "",
                notes: "",
              },
            ];
          }
        });
    },

    revisionDemandSolution() {
      this.isLoading = true;
      this.$store
        .dispatch("ideation/REVISION_DEMAND_SOLUTION", {
          id: this.ideationId,
          notes: this.bodyNotes,
        })
        .then(() => {
          this.isLoading = false;
          this.$swal("Saved", "Your input has been saved", "success").then(
            () => {
              this.$router.push({
                name: "Ideation",
              });
            }
          );
        })
        .catch((err) => {
          this.isLoading = false;
          this.$swal("Error", `${err.response.data.error}`, "error");
        });
    },

    // Action Role DIFO
    openModalDifo(type) {
      this.$store
        .dispatch("ideation/GET_DRAFT_DIFO", this.ideationId)
        .then(() => {
          this.$bvModal.show("modal-demand-touchpoint");
          (this.typeAction = type),
            (this.isFlow = "Technical Spesification Design (TSD)");
          let datas =
            this.$store.getters["ideation/notesDraft"]
              .technical_spesification_design;
          if (datas) {
            this.bodyVerifDP = datas;
          } else {
            this.bodyVerifDP = [
              {
                title: "Technical Derivative HSD",
                link: "",
                notes: "",
              },
              {
                title: "Infrastructure Plan",
                link: "",
                notes: "",
              },
              {
                title: "Security Design",
                link: "",
                notes: "",
              },
              {
                title: "Test Plan",
                link: "",
                notes: "",
              },
              {
                title: "DevOps Pipeline Design",
                link: "",
                notes: "",
              },
              {
                title: "Estimate Effort",
                link: "",
                notes: "",
              },
            ];
          }
        });
    },

    revisionDIFO() {
      this.isLoading = true;
      this.$store
        .dispatch("ideation/REVISION_DIFO", {
          id: this.ideationId,
          notes: this.bodyNotes,
        })
        .then(() => {
          this.isLoading = false;
          this.$swal("Saved", "Your input has been saved", "success").then(
            () => {
              this.$router.push({
                name: "Ideation",
              });
            }
          );
        })
        .catch((err) => {
          this.isLoading = false;
          this.$swal("Error", `${err.response.data.error}`, "error");
        });
    },

    // Action Role SPG Finalization
    openModalSpgFinal(type) {
      this.$store
        .dispatch("ideation/GET_SPG_FINALIZATION_DRAFT", this.ideationId)
        .then(() => {
          let data =
            this.$store.getters["ideation/notesDraft"].requirement_boarding_spg;
          this.$bvModal.show("modal-demand-touchpoint");
          (this.typeAction = type),
            (this.isFlow = "Requirement Boarding of SPG");
          if (data) {
            this.bodyVerifDP = data;
          } else {
            this.bodyVerifDP = [
              {
                title: "Sourcing Strategy",
                link: "",
                notes: "",
              },
              {
                title: "Timeline",
                link: "",
                notes: "",
              },
              {
                title: "Nomination of CDM & Co-CDM",
                link: "",
                notes: "",
              },
              {
                title: "Project Charter",
                link: "",
                notes: "",
              },
              {
                title: "Scope Definition",
                link: "",
                notes: "",
              },
              {
                title: "Constraint",
                link: "",
                notes: "",
              },
            ];
          }
        });
    },
    revisionFinalization() {
      this.isLoading = true;
      this.$store
        .dispatch("ideation/REVISION_FINALIZATION", {
          id: this.ideationId,
          notes: this.bodyNotes,
        })
        .then(() => {
          this.isLoading = false;
          this.$swal("Saved", "Your input has been saved", "success").then(
            () => {
              this.$router.push({
                name: "Ideation",
              });
            }
          );
        })
        .catch((err) => {
          this.isLoading = false;
          this.$swal("Error", `${err.response.data.error}`, "error");
        });
    },

    // Action Role SPG Kickoff
    openModalSpgKickoff(type) {
      this.$store
        .dispatch("ideation/GET_SPG_KICKOFF_DRAFT", this.ideationId)
        .then(() => {
          let datas = this.$store.getters["ideation/notesDraft"];
          if (type == "verif") {
            this.bodyNotes.notes = datas.notes;
          } else {
            this.bodyNotes.notes = "";
          }
          this.$bvModal.show("modal-spg-kickoff");
          this.typeAction = type;
        });
    },
    submitKickoffSpg(typeSave) {
      this.$swal({
        title: `Confirm ${typeSave}?`,
        text: `Are you sure want to ${typeSave} this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          if (typeSave == "revision") {
            this.$store
              .dispatch("ideation/REVISION_KICKOFF", {
                id: this.ideationId,
                notes: this.bodyNotes,
              })
              .then(() => {
                this.isLoading = false;
                this.$swal(
                  "Saved",
                  "Your input has been saved",
                  "success"
                ).then(() => {
                  this.$router.push({
                    name: "Ideation",
                  });
                });
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal("Error", `${err.response.data.error}`, "error");
              });
          } else {
            this.$validator.validateAll().then(async (res) => {
              if (!res) return false;
              try {
                if (typeSave == "submit") {
                  this.$store
                    .dispatch("ideation/KICKOFF_BY_SPG", {
                      id: this.ideationId,
                      notes: this.bodyNotes,
                    })
                    .then(() => {
                      this.isLoading = false;
                      this.$swal(
                        "Saved",
                        "Your input has been saved",
                        "success"
                      ).then(() => {
                        this.$router.push({
                          name: "Ideation",
                        });
                      });
                    })
                    .catch((err) => {
                      this.isLoading = false;
                      this.$swal(
                        "Error",
                        `${err.response.data.error}`,
                        "error"
                      );
                    });
                } else {
                  this.$store
                    .dispatch("ideation/KICKOFF_BY_SPG_DRAFT", {
                      id: this.ideationId,
                      notes: this.bodyNotes,
                    })
                    .then(() => {
                      this.isLoading = false;
                      this.$swal(
                        "Saved",
                        "Your input has been saved to draft",
                        "success"
                      ).then(() => {
                        this.$router.push({
                          name: "Ideation",
                        });
                      });
                    })
                    .catch((err) => {
                      this.isLoading = false;
                      this.$swal(
                        "Error",
                        `${err.response.data.error}`,
                        "error"
                      );
                    });
                }
              } catch (resp) {
                this.$swal("Error", this.$t("Error while add data"), "error");
              }
            });
          }
        }
      });
    },

    // Action Role Project Development DIFO
    openModalProjectDevelopment(type) {
      this.$bvModal.show("modal-project-development-difo");
      this.typeAction = type;
      // this.$store.dispatch("ideation/GET_SPG_KICKOFF_DRAFT", this.ideationId).then(() => {
      //     let datas = this.$store.getters['ideation/notesDraft']
      //     if (type == 'verif') {
      //         this.bodyNotes.notes = datas.notes
      //     } else {
      //         this.bodyNotes.notes = ""
      //     }
      //     this.$bvModal.show("modal-spg-kickoff")
      //     this.typeAction = type

      // })
    },
    newModule() {
      if (this.typeAction === "final" && this.bodyDevDIFO.module.length >= 1) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          })
          .fire({
            icon: "error",
            title: `You can only add 1 module when Final Realese`,
          });
        return;
      }

      this.bodyDevDIFO.module.push({
        name: "",
        feature: [],
      });
    },
    addFeature(index) {
      this.bodyDevDIFO.module[index].feature.push("");
    },
    removeFeature(modulIndex, featureIndex) {
      this.bodyDevDIFO.module[modulIndex].feature.splice(featureIndex, 1);
    },
    removeModule(index) {
      this.bodyDevDIFO.module.splice(index, 1);
    },
    submitProjectDevelopment() {
      this.$swal({
        title: "Confirm Submit?",
        text: `Are you sure want to ${
          this.typeAction == "final" ? "Full Realese" : "Partial Realese"
        }?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          let data = {
            module: this.bodyDevDIFO.module,
            notes: this.bodyNotes.notes,
          };
          if (this.typeAction == "final") {
            data.module = Object.fromEntries(
              this.bodyDevDIFO.module.map((item) => ["module", item])
            );
            data.module = data.module.module;
          }
          let body = {
            id: this.ideationId,
            body: data,
            type: this.typeAction,
          };
          this.$store
            .dispatch("ideation/SUBMIT_PROJECT_DEVELOPMENT", body)
            .then((resp) => {
              this.isLoading = false;
              this.$swal("Saved", "Your input has been saved", "success").then(
                () => {
                  this.$router.push({
                    name: "Ideation",
                  });
                }
              );
            })
            .catch((err) => {
              this.isLoading = false;
              this.$swal("Error", `${err.response.data.error}`, "error");
            });
        }
      });
    },
    checkData(data) {
      if (typeof data === "object" && !Array.isArray(data)) {
        const convertedData = Object.entries(data).map(([key, value]) => ({
          key,
          value,
        }));
        return convertedData;
      }

      return data;
    },
    convertFeature(data) {
      return data.join(", ");
    },

    openModalDetailDevelopment(data) {
      this.dataDetails = data;
      setTimeout(() => {
        this.$bvModal.show("modal-detail-development");
      }, 100);
    },

    // SPG Pra Go Live
    openModalPragolive(type, id) {
      this.bodyVerifDP = [
        {
          title: "Sosialisasi",
          link: "",
          notes: "",
        },
        {
          title: "Training",
          link: "",
          notes: "",
        },
        {
          title: "BAST",
          link: "",
          notes: "",
        },
        {
          title: "Change Management",
          link: "",
          notes: "",
        },
      ];
      this.$bvModal.show("modal-development");
      this.typeAction = type;
      this.moduleId = id;
    },
    submitPraGolive() {
      this.$swal({
        title: `Confirm Pra Go Live?`,
        text: `Are you sure want to submit this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.isLoading = true;
              this.$store
                .dispatch("ideation/PRA_GOLIVE_SPG", {
                  id: this.ideationId,
                  module_id: this.moduleId,
                  pra_go_live: this.bodyVerifDP,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.getDetail();
                    this.$bvModal.hide("modal-development");
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } catch (resp) {
              this.$swal("Error", this.$t("Error while add data"), "error");
            }
          });
        }
      });
    },

    // Action Go live SPG
    openModalGoLive(type, id) {
      this.$bvModal.show("modal-development");
      this.typeAction = type;
      this.moduleId = id;
    },
    submitGolive() {
      this.$swal({
        title: `Confirm Go Live?`,
        text: `Are you sure want to submit this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.isLoading = true;
              this.$store
                .dispatch("ideation/GOLIVE_SPG", {
                  id: this.ideationId,
                  module_id: this.moduleId,
                  notes: this.bodyNotes,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.bodyNotes.notes = "";
                    this.getDetail();
                    this.$bvModal.hide("modal-development");
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } catch (resp) {
              this.$swal("Error", this.$t("Error while add data"), "error");
            }
          });
        }
      });
    },

    // Monitoring
    openModalMonitoring(type, id) {
      this.bodyVerifDP = {
        month_1: [
          {
            adoption_rate: "",
            benefit_realization: "",
            notes: "",
          },
        ],
        month_2: [
          {
            adoption_rate: "",
            benefit_realization: "",
            notes: "",
          },
        ],
        month_3: [
          {
            adoption_rate: "",
            benefit_realization: "",
            notes: "",
          },
        ],
      };
      this.$bvModal.show("modal-development");
      this.typeAction = type;
      this.moduleId = id;
    },
    submitMonitoring() {
      this.$swal({
        title: `Confirm Monitoring?`,
        text: `Are you sure want to submit this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.isLoading = true;
              this.$store
                .dispatch("ideation/MONITORING", {
                  id: this.ideationId,
                  module_id: this.moduleId,
                  body: this.bodyVerifDP,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.getDetail();
                    this.$bvModal.hide("modal-development");
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } catch (resp) {
              this.$swal("Error", this.$t("Error while add data"), "error");
            }
          });
        }
      });
    },
    checkLink(text) {
      const urlPattern =
        /((https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?)/g;
      return text.replace(urlPattern, (match) => {
        let url = match;
        if (!/^https?:\/\//i.test(match)) {
          url = "http://" + match;
        }
        return `<a href="${url}" target="_blank">${match}</a>`;
      });
    },
    functionLink(link) {
      if (!/^https?:\/\//i.test(link)) {
        link = "https://" + link;
      }
      window.open(link, "_blank").focus();
    },
    getHoldItems(dat, type) {
      if (type == "Hold") {
        return dat.filter((item) => item.action_type === "Hold");
      } else {
        return dat.filter((item) => item.action_type === "Unhold");
      }
    },
    changePage(type, page) {
      const total = this.totalPages(type);
      if (page < 1 || page > total) return;
      this.currentPage[type] = page;
    },
  },
};
</script>
<style>
.vsa-item__heading {
  width: 100%;
  height: 100%;
}

.vsa-item__heading,
.vsa-item__trigger {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.vsa-item__trigger {
  margin: 0;
  padding: 0;
  color: inherit;
  font-family: inherit;
  font-size: 16px;
  line-height: 1.15;
  border-width: 0;
  background-color: transparent;
  background-image: none;
  overflow: visible;
  text-transform: none;
  flex: 1 1 auto;
  color: var(--vsa-text-color);
  transition: all 0.2s linear;
  padding: var(--vsa-heading-padding);
}

.vsa-item__trigger[role="button"] {
  cursor: pointer;
}

.vsa-item__trigger[type="button"],
.vsa-item__trigger[type="reset"],
.vsa-item__trigger[type="submit"] {
  -webkit-appearance: button;
}

.vsa-item__trigger:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

.vsa-item__trigger::-moz-focus-inner,
.vsa-item__trigger[type="button"]::-moz-focus-inner,
.vsa-item__trigger[type="reset"]::-moz-focus-inner,
.vsa-item__trigger[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

.vsa-item__trigger:-moz-focusring,
.vsa-item__trigger[type="button"]:-moz-focusring,
.vsa-item__trigger[type="reset"]:-moz-focusring,
.vsa-item__trigger[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

.vsa-item__trigger:focus,
.vsa-item__trigger:hover {
  outline: none;
  background-color: var(--vsa-highlight-color);
  color: var(--vsa-bg-color);
}

.vsa-item__trigger__icon--is-default {
  width: 40px;
  height: 40px;
  transform: scale(var(--vsa-default-icon-size));
}

.vsa-item__trigger__icon--is-default:after,
.vsa-item__trigger__icon--is-default:before {
  background-color: var(--vsa-text-color);
  content: "";
  height: 3px;
  position: absolute;
  top: 10px;
  transition: all 0.13333s ease-in-out;
  width: 30px;
}

.vsa-item__trigger__icon--is-default:before {
  left: 0;
  transform: rotate(45deg) translate3d(8px, 22px, 0);
  transform-origin: 100%;
}

.vsa-item__trigger__icon--is-default:after {
  transform: rotate(-45deg) translate3d(-8px, 22px, 0);
  right: 0;
  transform-origin: 0;
}

.vsa-item__trigger[aria-expanded="true"]
  .vsa-item__trigger__icon--is-default:before {
  transform: rotate(45deg) translate3d(14px, 14px, 0);
}

.vsa-item__trigger[aria-expanded="true"]
  .vsa-item__trigger__icon--is-default:after {
  transform: rotate(-45deg) translate3d(-14px, 14px, 0);
}

.vsa-item__trigger__icon {
  display: block;
  margin-left: auto;
  position: relative;
  transition: all 0.2s ease-in-out;
}

.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:after,
.vsa-item__trigger:focus .vsa-item__trigger__icon--is-default:before,
.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:after,
.vsa-item__trigger:hover .vsa-item__trigger__icon--is-default:before {
  background-color: var(--vsa-bg-color);
}

.vsa-item__trigger__content {
  font-weight: 700;
  font-size: 14px !important;
}

.vsa-item__content {
  margin: 0;
  padding: 20px 20px;
}

.vsa-item--is-active .vsa-item__heading,
.vsa-item:not(:last-of-type) {
  border-bottom: var(--vsa-border);
}

.vsa-collapse-enter-active,
.vsa-collapse-leave-active {
  transition-property: opacity, height, padding-top, padding-bottom;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
}

.vsa-collapse-enter,
.vsa-collapse-leave-active {
  opacity: 0;
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.vsa-list {
  --vsa-max-width: 720px;
  --vsa-min-width: 300px;
  --vsa-heading-padding: 10px 10px;
  --vsa-text-color: #373737;
  --vsa-highlight-color: #a12529;
  --vsa-bg-color: #fff;
  --vsa-border-color: rgba(0, 0, 0, 0.2);
  --vsa-border-width: 1px;
  --vsa-border-style: solid;
  --vsa-border: var(--vsa-border-width) var(--vsa-border-style)
    var(--vsa-border-color);
  --vsa-content-padding: 1rem 1rem;
  --vsa-default-icon-size: 1;
  display: block;
  max-width: var(--vsa-max-width);
  min-width: var(--vsa-min-width);
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  border: var(--vsa-border);
  color: var(--vsa-text-color);
  background-color: var(--vsa-bg-color);
}

.vsa-list [hidden] {
  display: none;
}
</style>
<style lang="scss" scoped>
.vsa-item {
  &--is-active {
    .vsa-item__trigger__icon {
      .isOpen {
        display: none;
      }

      .isClose {
        display: block;
      }
    }
  }

  &__trigger__icon {
    .isOpen {
      display: block;
    }

    .isClose {
      display: none;
    }
  }
}
</style>
